/** Google Ads UI and operation messages. API values and user content remain unchanged. */
export const googleAdsCopy = {
  "pauseCampaign": {"tr": "⏸ Duraklat", "en": "⏸ Pause"},
  "addToCampaign": {"tr": "Kampanyaya ekle", "en": "Add to campaign"},
  "googleAdsConnection": {"tr": "Google Ads bağlantısı", "en": "Google Ads connection"},
  "googleConnecting": {"tr": "Google hesabı bağlanıyor…", "en": "Connecting Google account…"},
  "googleBusinessConnection": {"tr": "Google Business bağlantısı", "en": "Google Business connection"},
  "returnToWorkspace": {"tr": "Workspace’e dön", "en": "Return to workspace"},
  "googleCodeMissing": {"tr": "Google doğrulama kodu bulunamadı.", "en": "Google authorization code not found."},
  "connectionIncomplete": {"tr": "Bağlantı tamamlanamadı.", "en": "Could not complete the connection."},
  "googleConnectionIncomplete": {"tr": "Google bağlantısı tamamlanamadı.", "en": "Could not complete the Google connection."},
  "adsAccountConnected": {"tr": "Google Ads hesabı bağlandı. Reklam hesaplarını workspace’e atayabilirsiniz.", "en": "Google Ads account connected. You can assign advertising accounts to your workspace."},
  "businessAccountConnected": {"tr": "Google hesabı bağlandı. Konumları workspace’e atayabilirsiniz.", "en": "Google account connected. You can assign locations to your workspace."},

  "exampleDomain": {"tr":"www.ornek.com","en":"www.example.com"},
  "aymudoWorkspace": {
    "tr": "AYMUDO / WORKSPACE",
    "en": "AYMUDO / WORKSPACE"
  },
  "advertising": {
    "tr": "Reklamlar",
    "en": "Advertising"
  },
  "yourAccountsCampaignsAndPerformanceInOne": {
    "tr": "Hesaplarınız, kampanyalarınız ve performansınız tek merkezde.",
    "en": "Your accounts, campaigns and performance in one place."
  },
  "close": {
    "tr": "Kapat ✕",
    "en": "Close ✕"
  },
  "adType": {
    "tr": "Reklam türü",
    "en": "Ad type"
  },
  "metaAds": {
    "tr": "◈ Meta reklamları",
    "en": "◈ Meta ads"
  },
  "googleAds": {
    "tr": "◉ Google reklamları",
    "en": "◉ Google ads"
  },
  "googleAds2": {
    "tr": "GOOGLE ADS",
    "en": "GOOGLE ADS"
  },
  "connectGoogleAccount": {
    "tr": "Google hesabı bağla",
    "en": "Connect Google account"
  },
  "advertisingAccounts": {
    "tr": "Reklam hesapları",
    "en": "Advertising accounts"
  },
  "g": {
    "tr": "G",
    "en": "G"
  },
  "manager": {
    "tr": "· Yönetici",
    "en": "· Manager"
  },
  "linkToWorkspace": {
    "tr": "Workspace’e bağla",
    "en": "Link to workspace"
  },
  "refreshAccounts": {
    "tr": "↻ Hesapları yenile",
    "en": "↻ Refresh accounts"
  },
  "googleSessionS": {
    "tr": "Google oturumu ·",
    "en": "Google session(s) ·"
  },
  "accountS": {
    "tr": "hesap",
    "en": "account(s)"
  },
  "campaignOptions": {
    "tr": "Kampanya seçenekleri",
    "en": "Campaign options"
  },
  "accountOverview": {
    "tr": "Hesap özeti",
    "en": "Account overview"
  },
  "imageLibrary": {
    "tr": "Görsel kütüphanesi",
    "en": "Image library"
  },
  "campaignManagement": {
    "tr": "Kampanya yönetimi",
    "en": "Campaign management"
  },
  "customerId": {
    "tr": "Müşteri numarası",
    "en": "Customer ID"
  },
  "managementCenter": {
    "tr": "Yönetim merkezi",
    "en": "Management center"
  },
  "images": {
    "tr": "▧ Görseller",
    "en": "▧ Images"
  },
  "newCampaign": {
    "tr": "＋ Yeni kampanya",
    "en": "＋ New campaign"
  },
  "linkThisAccountToYourWorkspace": {
    "tr": "Bu hesabı workspace’e bağlayın",
    "en": "Link this account to your workspace"
  },
  "campaignAndSpendingDataBecomeAvailableAfter": {
    "tr": "Kampanya ve harcama verileri bağlantıdan sonra açılır.",
    "en": "Campaign and spending data become available after linking."
  },
  "managerAccount": {
    "tr": "Yönetici hesabı",
    "en": "Manager account"
  },
  "returnToTheAccountListAndSelect": {
    "tr": "Kampanyaları görmek için hesap listesine dönüp alt reklam hesabını seçin.",
    "en": "Return to the account list and select a client advertising account to see campaigns."
  },
  "step": {
    "tr": "ADIM",
    "en": "STEP"
  },
  "campaignType": {
    "tr": "Kampanya türü",
    "en": "Campaign type"
  },
  "searchAd": {
    "tr": "Arama reklamı",
    "en": "Search ad"
  },
  "reachCustomersSearchingForYourServicesOn": {
    "tr": "Google aramalarında hizmet arayan müşterilere ulaşın. Metin, anahtar kelime ve hedef adresi.",
    "en": "Reach customers searching for your services on Google with text, keywords and a destination URL."
  },
  "displayAd": {
    "tr": "Görsel reklam",
    "en": "Display ad"
  },
  "promoteYourBrandAcrossTheGoogleDisplay": {
    "tr": "Google Görüntülü Reklam Ağı’nda görseller, logo ve metinlerle markanızı tanıtın.",
    "en": "Promote your brand across the Google Display Network with images, logos and text."
  },
  "createPerformanceMaxDemandGenShoppingOr": {
    "tr": "Performance Max, Demand Gen, Alışveriş veya Uygulama oluştur ›",
    "en": "Create Performance Max, Demand Gen, Shopping or App ›"
  },
  "isAWebsiteRequired": {
    "tr": "Web sitesi gerekiyor mu?",
    "en": "Is a website required?"
  },
  "performanceMaxDemandGenYoutubeVideoShopping": {
    "tr": "Performance Max, Demand Gen, YouTube/video, Alışveriş ve Uygulama kampanyaları farklı hedefler ve hesap bağlantıları kullanır. Bu türleri yönetim merkezinden oluşturabilirsiniz.",
    "en": "Performance Max, Demand Gen, YouTube/video, Shopping and App campaigns use different goals and account links. Create them in the management center."
  },
  "searchAndDisplayAdsInThisFlow": {
    "tr": "Bu akıştaki Arama ve görsel reklamlar için geçerli bir hedef adresi gerekir. Kendinize ait bir web sitesi olmak zorunda değil; yönetebildiğiniz, reklamınızla uyumlu bir açılış sayfası kullanılabilir. Uygulama reklamları mağaza sayfasına yönlenir. Smart kampanyalarda işletme profiliyle açılış sayfası mümkün olsa da Google yeni Smart kampanyaların API’den oluşturulmasını kapattı.",
    "en": "Search and Display ads in this flow require a valid destination URL. You can use a relevant landing page you manage; it does not have to be your own website. App ads link to an app store page. Although Smart campaigns can use a Business Profile landing page, Google no longer allows creating new Smart campaigns through the API."
  },
  "campaignName": {
    "tr": "Kampanya adı",
    "en": "Campaign name"
  },
  "eGIstanbulNewCustomers": {
    "tr": "Örn. İstanbul yeni müşteriler",
    "en": "e.g. Istanbul new customers"
  },
  "dailyBudget": {
    "tr": "Günlük bütçe (",
    "en": "Daily budget ("
  },
  "destinationUrl": {
    "tr": "Hedef adresi",
    "en": "Destination URL"
  },
  "https": {
    "tr": "https://...",
    "en": "https://..."
  },
  "thePageCustomersOpenWhenTheyClick": {
    "tr": "Reklama tıklayan müşterinin açacağı sayfa.",
    "en": "The page customers open when they click your ad."
  },
  "biddingStrategy": {
    "tr": "Teklif stratejisi",
    "en": "Bidding strategy"
  },
  "manualCpc": {
    "tr": "Manuel tıklama başı teklif",
    "en": "Manual CPC"
  },
  "maximizeClicks": {
    "tr": "Tıklamaları artır",
    "en": "Maximize clicks"
  },
  "maximizeConversions": {
    "tr": "Dönüşümleri artır",
    "en": "Maximize conversions"
  },
  "cpcBidLimit": {
    "tr": "Tıklama başı teklif / üst sınır (",
    "en": "CPC bid / limit ("
  },
  "thisStrategyRequiresConversionTrackingToBe": {
    "tr": "Bu strateji için Google Ads hesabınızda doğru dönüşüm ölçümü kurulmuş olmalı.",
    "en": "This strategy requires conversion tracking to be configured correctly in your Google Ads account."
  },
  "startDateOptional": {
    "tr": "Başlangıç tarihi (isteğe bağlı)",
    "en": "Start date (optional)"
  },
  "endDateOptional": {
    "tr": "Bitiş tarihi (isteğe bağlı)",
    "en": "End date (optional)"
  },
  "includeGoogleSearchPartners": {
    "tr": "Google arama iş ortaklarında da göster",
    "en": "Include Google search partners"
  },
  "theCampaignIsCreatedPausedEnableIt": {
    "tr": "Kampanya duraklatılmış oluşturulur. Hazır olduğunuzda yayına alabilirsiniz. Tarihler reklam hesabının",
    "en": "The campaign is created paused. Enable it when ready. Dates use the account’s"
  },
  "timeZone": {
    "tr": "saat dilimindedir.",
    "en": "time zone."
  },
  "selectRegion": {
    "tr": "Bölge seç",
    "en": "Select region"
  },
  "radiusInKilometers": {
    "tr": "Kilometre yarıçapı",
    "en": "Radius in kilometers"
  },
  "searchRegion": {
    "tr": "Bölge ara",
    "en": "Search region"
  },
  "cityDistrictOrRegion": {
    "tr": "İl, ilçe veya bölge",
    "en": "City, district or region"
  },
  "search": {
    "tr": "Ara",
    "en": "Search"
  },
  "selectedRegion": {
    "tr": "Seçilen bölge:",
    "en": "Selected region:"
  },
  "city": {
    "tr": "Şehir",
    "en": "City"
  },
  "istanbul": {
    "tr": "İstanbul",
    "en": "Istanbul"
  },
  "radiusKm": {
    "tr": "Yarıçap (km)",
    "en": "Radius (km)"
  },
  "streetAddress": {
    "tr": "Açık adres",
    "en": "Street address"
  },
  "streetAndRoadOptional": {
    "tr": "Cadde ve sokak (isteğe bağlı)",
    "en": "Street and road (optional)"
  },
  "googleTargetsPeopleAroundTheAddressYou": {
    "tr": "Google, belirttiğiniz adresin çevresindeki kitleyi hedefler.",
    "en": "Google targets people around the address you provide."
  },
  "keywords": {
    "tr": "Anahtar kelimeler",
    "en": "Keywords"
  },
  "oneSearchPhrasePerLinePhraseMatch": {
    "tr": "Her satıra bir arama ifadesi · Sıralı eşleme",
    "en": "One search phrase per line · Phrase match"
  },
  "exampleServiceExampleServiceNearMe": {
    "tr": "örnek hizmet\nyakınımdaki örnek hizmet",
    "en": "example service\nexample service near me"
  },
  "negativeKeywords": {
    "tr": "Hariç tutulan kelimeler",
    "en": "Negative keywords"
  },
  "adsWillNotAppearForSearchesContaining": {
    "tr": "Bu ifadelerle yapılan aramalarda gösterilmez.",
    "en": "Ads will not appear for searches containing these phrases."
  },
  "freeJobVacancy": {
    "tr": "ücretsiz\niş ilanı",
    "en": "free\njob vacancy"
  },
  "prelaunchReview": {
    "tr": "Yayın öncesi kontrol",
    "en": "Prelaunch review"
  },
  "campaign": {
    "tr": "Kampanya",
    "en": "Campaign"
  },
  "dailyBudget2": {
    "tr": "Günlük bütçe",
    "en": "Daily budget"
  },
  "targeting": {
    "tr": "Hedefleme",
    "en": "Targeting"
  },
  "allRegions": {
    "tr": "Tüm bölgeler",
    "en": "All regions"
  },
  "type": {
    "tr": "Tür",
    "en": "Type"
  },
  "images2": {
    "tr": "Görseller",
    "en": "Images"
  },
  "assetS": {
    "tr": "öğe",
    "en": "asset(s)"
  },
  "status": {
    "tr": "Durum",
    "en": "Status"
  },
  "paused": {
    "tr": "Duraklatılmış",
    "en": "Paused"
  },
  "validateInGoogleAds": {
    "tr": "Google Ads’te doğrula",
    "en": "Validate in Google Ads"
  },
  "googleAdsValidationSuccessful": {
    "tr": "✓ Google Ads doğrulaması başarılı.",
    "en": "✓ Google Ads validation successful."
  },
  "selectedAdImage": {
    "tr": "Seçilen reklam görseli",
    "en": "Selected ad image"
  },
  "adPreview": {
    "tr": "REKLAM ÖNİZLEMESİ",
    "en": "AD PREVIEW"
  },
  "ad": {
    "tr": "Reklam ·",
    "en": "Ad ·"
  },
  "back": {
    "tr": "← Geri",
    "en": "← Back"
  },
  "next": {
    "tr": "Devam →",
    "en": "Next →"
  },
  "createPausedCampaign": {
    "tr": "Duraklatılmış kampanya oluştur",
    "en": "Create paused campaign"
  },
  "campaign2": {
    "tr": "KAMPANYASI",
    "en": "CAMPAIGN"
  },
  "enable": {
    "tr": "▶ Yayına al",
    "en": "▶ Enable"
  },
  "advancedCampaignManagement": {
    "tr": "Gelişmiş kampanya yönetimi",
    "en": "Advanced campaign management"
  },
  "reportsTargetingKeywordsAssetGroupsAndDate": {
    "tr": "Raporlar, hedefleme, kelimeler, öğe grupları ve tarih ayarları",
    "en": "Reports, targeting, keywords, asset groups and date settings"
  },
  "budgetAndBidding": {
    "tr": "Bütçe ve teklif",
    "en": "Budget and bidding"
  },
  "manageDailySpendingLimits": {
    "tr": "Günlük harcama sınırını yönetin",
    "en": "Manage daily spending limits"
  },
  "locationTargeting": {
    "tr": "Konum hedefleme",
    "en": "Location targeting"
  },
  "selectARegionOrKilometerRadius": {
    "tr": "Bölge veya kilometre yarıçapı seçin",
    "en": "Select a region or kilometer radius"
  },
  "keywordSManageSearchPhrases": {
    "tr": "kelime · Arama ifadelerini yönetin",
    "en": "keyword(s) · Manage search phrases"
  },
  "adContent": {
    "tr": "Reklam içerikleri",
    "en": "Ad content"
  },
  "adSCreateANewAd": {
    "tr": "reklam · Yeni reklam hazırlayın",
    "en": "ad(s) · Create a new ad"
  },
  "callsAndAdAssets": {
    "tr": "Telefon ve reklam öğeleri",
    "en": "Calls and ad assets"
  },
  "callsSitelinksAndCallouts": {
    "tr": "Arama, site bağlantıları ve vurgu metinleri",
    "en": "Calls, sitelinks and callouts"
  },
  "openThisCampaignSAutomatedSettingsIn": {
    "tr": "Bu kampanyanın otomatik ayarlarını Google Ads’te aç ↗",
    "en": "Open this campaign’s automated settings in Google Ads ↗"
  },
  "adAssets": {
    "tr": "Reklam öğeleri",
    "en": "Ad assets"
  },
  "edit": {
    "tr": "Düzenle",
    "en": "Edit"
  },
  "enable2": {
    "tr": "Etkinleştir",
    "en": "Enable"
  },
  "remove": {
    "tr": "Kaldır",
    "en": "Remove"
  },
  "newAssetType": {
    "tr": "Yeni öğe türü",
    "en": "New asset type"
  },
  "phoneCall": {
    "tr": "Telefon araması",
    "en": "Phone call"
  },
  "sitelink": {
    "tr": "Site bağlantısı",
    "en": "Sitelink"
  },
  "callout": {
    "tr": "Vurgu metni",
    "en": "Callout"
  },
  "phone": {
    "tr": "Telefon",
    "en": "Phone"
  },
  "countryCode": {
    "tr": "Ülke kodu",
    "en": "Country code"
  },
  "tr": {
    "tr": "TR",
    "en": "TR"
  },
  "linkText": {
    "tr": "Bağlantı metni",
    "en": "Link text"
  },
  "eGFreeConsultation": {
    "tr": "Örn. Ücretsiz danışmanlık",
    "en": "e.g. Free consultation"
  },
  "description1": {
    "tr": "Açıklama 1",
    "en": "Description 1"
  },
  "description2": {
    "tr": "Açıklama 2",
    "en": "Description 2"
  },
  "updateAsset": {
    "tr": "Öğeyi güncelle",
    "en": "Update asset"
  },
  "cancelNewAsset": {
    "tr": "Vazgeç / yeni öğe",
    "en": "Cancel / new asset"
  },
  "allCampaignsUsingThisAssetWillBe": {
    "tr": "Bu öğeyi kullanan tüm kampanyalar güncellenir.",
    "en": "All campaigns using this asset will be updated."
  },
  "googleDeterminesWhenTheseAssetsAppearBased": {
    "tr": "Google bu öğelerin gösterimini uygunluk ve reklam politikalarına göre belirler.",
    "en": "Google determines when these assets appear based on eligibility and ad policies."
  },
  "dailyBudget3": {
    "tr": "Günlük bütçe:",
    "en": "Daily budget:"
  },
  "newDailyBudget": {
    "tr": "Yeni günlük bütçe (",
    "en": "New daily budget ("
  },
  "updateBudget": {
    "tr": "Bütçeyi güncelle",
    "en": "Update budget"
  },
  "thisBudgetIsSharedManageChangesIn": {
    "tr": "Paylaşılan bütçe; değişiklik Google Ads üzerinden yönetilir.",
    "en": "This budget is shared; manage changes in Google Ads."
  },
  "biddingStrategy2": {
    "tr": "Teklif stratejisi:",
    "en": "Bidding strategy:"
  },
  "newBiddingStrategy": {
    "tr": "Yeni teklif stratejisi",
    "en": "New bidding strategy"
  },
  "maximizeConversionValue": {
    "tr": "Dönüşüm değerini artır",
    "en": "Maximize conversion value"
  },
  "maximumCpcBid": {
    "tr": "Tıklama başı teklif üst sınırı (",
    "en": "Maximum CPC bid ("
  },
  "targetCpaOptional": {
    "tr": "Hedef işlem maliyeti (isteğe bağlı)",
    "en": "Target CPA (optional)"
  },
  "targetRoasMultiplierOptional": {
    "tr": "Hedef ROAS çarpanı (isteğe bağlı)",
    "en": "Target ROAS multiplier (optional)"
  },
  "4400Return": {
    "tr": "4 = %400 getiri",
    "en": "4 = 400% return"
  },
  "maximizeConversionsRequiresTrackingToBeConfigured": {
    "tr": "Dönüşümleri artır stratejisi için ölçüm kurulmuş olmalı. Manuel tekliflerde reklam grubu teklifleri kullanılır.",
    "en": "Maximize conversions requires tracking to be configured. Manual bidding uses ad group bids."
  },
  "updateBiddingStrategy": {
    "tr": "Teklif stratejisini güncelle",
    "en": "Update bidding strategy"
  },
  "locationTargets": {
    "tr": "Konum hedefleri",
    "en": "Location targets"
  },
  "region": {
    "tr": "Bölge",
    "en": "Region"
  },
  "km": {
    "tr": "Km",
    "en": "Km"
  },
  "newRegion": {
    "tr": "Yeni bölge",
    "en": "New region"
  },
  "selected": {
    "tr": "Seçilen:",
    "en": "Selected:"
  },
  "address": {
    "tr": "Adres",
    "en": "Address"
  },
  "updateTargeting": {
    "tr": "Hedeflemeyi güncelle",
    "en": "Update targeting"
  },
  "adGroups": {
    "tr": "Reklam grupları",
    "en": "Ad groups"
  },
  "manageThePhrasesYourAdsAppearFor": {
    "tr": "Aramalarda hangi ifadelerle görüneceğinizi yönetin.",
    "en": "Manage the phrases your ads appear for in searches."
  },
  "adGroup": {
    "tr": "Reklam grubu",
    "en": "Ad group"
  },
  "newKeyword": {
    "tr": "Yeni anahtar kelime",
    "en": "New keyword"
  },
  "eGIstanbulHairdresser": {
    "tr": "ör. İstanbul kuaför",
    "en": "e.g. Istanbul hairdresser"
  },
  "matchType": {
    "tr": "Eşleme türü",
    "en": "Match type"
  },
  "phraseMatch": {
    "tr": "Sıralı eşleme",
    "en": "Phrase match"
  },
  "exactMatch": {
    "tr": "Tam eşleme",
    "en": "Exact match"
  },
  "broadMatch": {
    "tr": "Geniş eşleme",
    "en": "Broad match"
  },
  "addKeyword": {
    "tr": "Anahtar kelime ekle",
    "en": "Add keyword"
  },
  "newAdsAreAddedPausedEnableThem": {
    "tr": "Yeni reklam taslak olarak eklenir; hazır olduğunda Google Ads’te yayına alabilirsiniz.",
    "en": "New ads are added paused; enable them in Google Ads when ready."
  },
  "underReview": {
    "tr": "İncelemede",
    "en": "Under review"
  },
  "enable3": {
    "tr": "Yayına al",
    "en": "Enable"
  },
  "duplicate": {
    "tr": "Kopyala",
    "en": "Duplicate"
  },
  "destinationWebsiteUrl": {
    "tr": "Hedef web adresi",
    "en": "Destination website URL"
  },
  "updateAd": {
    "tr": "Reklamı güncelle",
    "en": "Update ad"
  },
  "createPausedAd": {
    "tr": "Duraklatılmış reklam oluştur",
    "en": "Create paused ad"
  },
  "performance": {
    "tr": "PERFORMANS",
    "en": "PERFORMANCE"
  },
  "overview": {
    "tr": "Genel görünüm",
    "en": "Overview"
  },
  "start": {
    "tr": "Başlangıç",
    "en": "Start"
  },
  "end": {
    "tr": "Bitiş",
    "en": "End"
  },
  "apply": {
    "tr": "Uygula",
    "en": "Apply"
  },
  "totalSpend": {
    "tr": "TOPLAM HARCAMA",
    "en": "TOTAL SPEND"
  },
  "selectedPeriod": {
    "tr": "Seçilen dönem",
    "en": "Selected period"
  },
  "impressions": {
    "tr": "GÖSTERİM",
    "en": "IMPRESSIONS"
  },
  "adImpressions": {
    "tr": "Reklam görüntülenmesi",
    "en": "Ad impressions"
  },
  "clicks": {
    "tr": "TIKLAMA",
    "en": "CLICKS"
  },
  "ctr": {
    "tr": "TO",
    "en": "CTR"
  },
  "conversions": {
    "tr": "DÖNÜŞÜM",
    "en": "CONVERSIONS"
  },
  "value": {
    "tr": "değer",
    "en": "value"
  },
  "dailySpend": {
    "tr": "Günlük harcama",
    "en": "Daily spend"
  },
  "paymentStatus": {
    "tr": "ÖDEME DURUMU",
    "en": "PAYMENT STATUS"
  },
  "billingInformation": {
    "tr": "Faturalama bilgisi",
    "en": "Billing information"
  },
  "paymentsAccount": {
    "tr": "Ödeme hesabı",
    "en": "Payments account"
  },
  "invoice": {
    "tr": "Fatura",
    "en": "Invoice"
  },
  "dueDate": {
    "tr": "· Son gün",
    "en": "· Due date"
  },
  "googleAdsPayments": {
    "tr": "Google Ads ödemeleri ↗",
    "en": "Google Ads payments ↗"
  },
  "campaigns": {
    "tr": "KAMPANYALAR",
    "en": "CAMPAIGNS"
  },
  "activeWorkspace": {
    "tr": "Aktif çalışma alanı",
    "en": "Active workspace"
  },
  "campaignS": {
    "tr": "kampanya",
    "en": "campaign(s)"
  },
  "showingTheFirst500Campaigns": {
    "tr": "İlk 500 kampanya gösteriliyor.",
    "en": "Showing the first 500 campaigns."
  },
  "enabled": {
    "tr": "Yayında",
    "en": "Enabled"
  },
  "paused2": {
    "tr": "Duraklatıldı",
    "en": "Paused"
  },
  "clickS": {
    "tr": "tıklama",
    "en": "click(s)"
  },
  "loadingReport": {
    "tr": "Rapor yükleniyor",
    "en": "Loading report"
  },
  "campaignsAndSpendingForTheSelectedDates": {
    "tr": "Kampanyalar ve seçilen tarihteki harcamalar burada görünecek.",
    "en": "Campaigns and spending for the selected dates will appear here."
  },
  "selectAnAdvertisingAccount": {
    "tr": "Bir reklam hesabı seçin",
    "en": "Select an advertising account"
  },
  "viewSpendingCampaignsAndBillingInformation": {
    "tr": "Harcama, kampanya ve faturalama bilgilerini görüntüleyin.",
    "en": "View spending, campaigns and billing information."
  },
  "googleAdsImages": {
    "tr": "GOOGLE ADS GÖRSELLERİ",
    "en": "GOOGLE ADS IMAGES"
  },
  "refresh": {
    "tr": "Yenile",
    "en": "Refresh"
  },
  "reuseAccountImagesOrUploadJpegPng": {
    "tr": "Hesabınızdaki görselleri tekrar kullanın veya cihazdan JPEG / PNG yükleyin. Yüklemek tek başına reklamı yayına almaz.",
    "en": "Reuse account images or upload JPEG / PNG files from your device. Uploading alone does not publish an ad."
  },
  "selectImageFromDevice": {
    "tr": "＋ Cihazdan görsel seç",
    "en": "＋ Select image from device"
  },
  "maximum5MbLandscapeAtLeast600": {
    "tr": "En fazla 5 MB. Yatay: en az 600×314 (1,91:1); kare: en az 300×300. Kare logo: en az 128×128.",
    "en": "Maximum 5 MB. Landscape: at least 600×314 (1.91:1); square: at least 300×300. Square logo: at least 128×128."
  },
  "imageToUpload": {
    "tr": "Yüklenecek görsel",
    "en": "Image to upload"
  },
  "px": {
    "tr": "px",
    "en": "px"
  },
  "uploadToGoogleAds": {
    "tr": "Google Ads’e yükle",
    "en": "Upload to Google Ads"
  },
  "cancel": {
    "tr": "Vazgeç",
    "en": "Cancel"
  },
  "landscape": {
    "tr": "Yatay ·",
    "en": "Landscape ·"
  },
  "square": {
    "tr": "Kare ·",
    "en": "Square ·"
  },
  "logo": {
    "tr": "Logo ·",
    "en": "Logo ·"
  },
  "tapASelectedItemAgainToRemove": {
    "tr": "Seçtiklerinize tekrar dokunarak kaldırabilirsiniz.",
    "en": "Tap a selected item again to remove it."
  },
  "selectLandscapeAdImages": {
    "tr": "Yatay reklam görsellerini seçin.",
    "en": "Select landscape ad images."
  },
  "selectSquareAdImages": {
    "tr": "Kare reklam görsellerini seçin.",
    "en": "Select square ad images."
  },
  "aSquareLogoIsOptional": {
    "tr": "Kare logo isteğe bağlıdır.",
    "en": "A square logo is optional."
  },
  "selectedImage": {
    "tr": "Seçilen görsel",
    "en": "Selected image"
  },
  "openFullSizeImage": {
    "tr": "Görseli tam boyutta aç ↗",
    "en": "Open full-size image ↗"
  },
  "close2": {
    "tr": "Kapat",
    "en": "Close"
  },
  "adImage": {
    "tr": "Reklam görseli",
    "en": "Ad image"
  },
  "selected2": {
    "tr": "✓ Seçildi",
    "en": "✓ Selected"
  },
  "select": {
    "tr": "Seç",
    "en": "Select"
  },
  "notSuitableForThisFormat": {
    "tr": "Bu biçime uygun değil",
    "en": "Not suitable for this format"
  },
  "whoShouldWeTarget": {
    "tr": "Kimi hedefleyeceğiz?",
    "en": "Who should we target?"
  },
  "adContent2": {
    "tr": "Reklam içeriği",
    "en": "Ad content"
  },
  "setTheBudgetAndDestinationUrlFor": {
    "tr": "Bütçeyi ve ziyaretçilerin gideceği adresi belirleyin.",
    "en": "Set the budget and destination URL for visitors."
  },
  "selectARegionOrRadiusInKilometers": {
    "tr": "Bölge ya da kilometre yarıçapı seçin.",
    "en": "Select a region or radius in kilometers."
  },
  "selectImagesAndPrepareYourAdText": {
    "tr": "Görsellerinizi seçin ve reklam metnini hazırlayın.",
    "en": "Select images and prepare your ad text."
  },
  "prepareSearchPhrasesAndAdText": {
    "tr": "Arama ifadelerini ve reklam metinlerini hazırlayın.",
    "en": "Prepare search phrases and ad text."
  },
  "createThePausedCampaignAfterGoogleAds": {
    "tr": "Google Ads doğrulamasından sonra taslak kampanyayı oluşturun.",
    "en": "Create the paused campaign after Google Ads validation."
  },
  "theGoogleAdsOperationCouldNotBe": {
    "tr": "Google Ads işlemi tamamlanamadı.",
    "en": "The Google Ads operation could not be completed."
  },
  "theOperationCouldNotBeCompleted": {
    "tr": "İşlem tamamlanamadı.",
    "en": "The operation could not be completed."
  },
  "refreshingGoogleAccounts": {
    "tr": "Google hesapları yenileniyor…",
    "en": "Refreshing Google accounts…"
  },
  "loadingGoogleAds": {
    "tr": "Google Ads yükleniyor…",
    "en": "Loading Google Ads…"
  },
  "couldNotPrepareTheConnection": {
    "tr": "Bağlantı hazırlanamadı.",
    "en": "Could not prepare the connection."
  },
  "savingWorkspaceLink": {
    "tr": "Workspace bağlantısı kaydediliyor…",
    "en": "Saving workspace link…"
  },
  "fetchingCampaignsAndReports": {
    "tr": "Kampanyalar ve raporlar alınıyor…",
    "en": "Fetching campaigns and reports…"
  },
  "loadingCampaignDetails": {
    "tr": "Kampanya ayrıntısı yükleniyor…",
    "en": "Loading campaign details…"
  },
  "selectAnAdGroupAndKeyword": {
    "tr": "Reklam grubu ve anahtar kelime seçin.",
    "en": "Select an ad group and keyword."
  },
  "anAdGroupWebsiteUrlThreeHeadlines": {
    "tr": "Reklam grubu, web adresi, üç başlık ve iki açıklama gerekli.",
    "en": "An ad group, website URL, three headlines and two descriptions are required."
  },
  "creatingAd": {
    "tr": "Reklam oluşturuluyor…",
    "en": "Creating ad…"
  },
  "theAdWasCreatedPaused": {
    "tr": "Reklam duraklatılmış olarak oluşturuldu.",
    "en": "The ad was created paused."
  },
  "updatingBiddingStrategy": {
    "tr": "Teklif stratejisi güncelleniyor…",
    "en": "Updating bidding strategy…"
  },
  "biddingStrategyUpdated": {
    "tr": "Teklif stratejisi güncellendi.",
    "en": "Bidding strategy updated."
  },
  "updatingBudgetInGoogleAds": {
    "tr": "Bütçe Google Ads’te güncelleniyor…",
    "en": "Updating budget in Google Ads…"
  },
  "dailyBudgetUpdated": {
    "tr": "Günlük bütçe güncellendi.",
    "en": "Daily budget updated."
  },
  "updatingTargetingInGoogleAds": {
    "tr": "Hedefleme Google Ads’te güncelleniyor…",
    "en": "Updating targeting in Google Ads…"
  },
  "locationTargetingUpdated": {
    "tr": "Konum hedeflemesi güncellendi.",
    "en": "Location targeting updated."
  },
  "updatingCampaignStatus": {
    "tr": "Kampanya durumu güncelleniyor…",
    "en": "Updating campaign status…"
  },
  "campaignPaused": {
    "tr": "Kampanya duraklatıldı.",
    "en": "Campaign paused."
  },
  "campaignEnabled": {
    "tr": "Kampanya yayına alındı.",
    "en": "Campaign enabled."
  },
  "campaignNameDailyBudgetAndAValid": {
    "tr": "Kampanya adı, günlük bütçe ve geçerli hedef adresi gerekli.",
    "en": "Campaign name, daily budget and a valid destination URL are required."
  },
  "selectAValidRegionOrRadius": {
    "tr": "Geçerli bölge veya yarıçap seçin.",
    "en": "Select a valid region or radius."
  },
  "atLeastOneHeadlineAndDescriptionAre": {
    "tr": "En az bir başlık ve açıklama gerekli.",
    "en": "At least one headline and description are required."
  },
  "atLeastOneKeywordThreeHeadlinesAnd": {
    "tr": "En az bir anahtar kelime, üç başlık ve iki açıklama gerekli.",
    "en": "At least one keyword, three headlines and two descriptions are required."
  },
  "businessNameLongHeadlineLandscapeImageAnd": {
    "tr": "İşletme adı, uzun başlık, yatay ve kare görsel gerekli.",
    "en": "Business name, long headline, landscape image and square image are required."
  },
  "searchingRegions": {
    "tr": "Bölgeler aranıyor…",
    "en": "Searching regions…"
  },
  "validatingInGoogleAds": {
    "tr": "Google Ads kampanyayı doğruluyor…",
    "en": "Validating in Google Ads…"
  },
  "theCampaignChangedDuringValidationValidateIt": {
    "tr": "Doğrulama sırasında kampanya değişti. Tekrar doğrulayın.",
    "en": "The campaign changed during validation. Validate it again."
  },
  "googleAdsValidationSuccessfulTheCampaignHas": {
    "tr": "Google Ads doğrulaması başarılı. Kampanya henüz oluşturulmadı.",
    "en": "Google Ads validation successful. The campaign has not been created yet."
  },
  "campaignDetailsChangedValidateAgainBeforeCreating": {
    "tr": "Kampanya bilgileri değişti. Oluşturmadan önce tekrar doğrulayın.",
    "en": "Campaign details changed. Validate again before creating."
  },
  "creatingCampaignInGoogleAds": {
    "tr": "Kampanya Google Ads’te oluşturuluyor…",
    "en": "Creating campaign in Google Ads…"
  },
  "theCampaignWasCreatedPaused": {
    "tr": "Kampanya duraklatılmış olarak oluşturuldu.",
    "en": "The campaign was created paused."
  },
  "loadingImageLibrary": {
    "tr": "Görsel kütüphanesi yükleniyor…",
    "en": "Loading image library…"
  },
  "selectJpegPngOrGifMaximum5": {
    "tr": "JPEG, PNG veya GIF seçin; en fazla 5 MB.",
    "en": "Select JPEG, PNG or GIF; maximum 5 MB."
  },
  "couldNotReadTheFile": {
    "tr": "Dosya okunamadı.",
    "en": "Could not read the file."
  },
  "couldNotOpenTheImage": {
    "tr": "Görsel açılamadı.",
    "en": "Could not open the image."
  },
  "uploadingImageToGoogleAds": {
    "tr": "Görsel Google Ads’e yükleniyor…",
    "en": "Uploading image to Google Ads…"
  },
  "imageUploadedToTheGoogleAdsLibrary": {
    "tr": "Görsel Google Ads kütüphanesine yüklendi. Reklamda kullanmak için seçin.",
    "en": "Image uploaded to the Google Ads library. Select it to use it in an ad."
  },
  "doYouWantToRemoveThisAd": {
    "tr": "Bu reklamı kampanyadan kaldırmak istiyor musunuz?",
    "en": "Do you want to remove this ad from the campaign?"
  },
  "removingAd": {
    "tr": "Reklam kaldırılıyor…",
    "en": "Removing ad…"
  },
  "adRemoved": {
    "tr": "Reklam kaldırıldı.",
    "en": "Ad removed."
  },
  "youAreEditingAnExistingAdSaving": {
    "tr": "Mevcut reklamı düzenliyorsunuz. Kaydetme Google politika incelemesini yeniden başlatabilir.",
    "en": "You are editing an existing ad. Saving may restart Google’s policy review."
  },
  "updatingAd": {
    "tr": "Reklam güncelleniyor…",
    "en": "Updating ad…"
  },
  "adContentUpdated": {
    "tr": "Reklam içeriği güncellendi.",
    "en": "Ad content updated."
  },
  "textCopiedIntoTheEditorSavingWill": {
    "tr": "Metinler düzenleyiciye kopyalandı. Kaydettiğinizde yeni bir duraklatılmış reklam oluşur.",
    "en": "Text copied into the editor. Saving will create a new paused ad."
  },
  "updatingAdStatus": {
    "tr": "Reklam durumu güncelleniyor…",
    "en": "Updating ad status…"
  },
  "adStatusUpdated": {
    "tr": "Reklam durumu güncellendi.",
    "en": "Ad status updated."
  },
  "youAreEditingAnExistingAdAsset": {
    "tr": "Mevcut reklam öğesini düzenliyorsunuz.",
    "en": "You are editing an existing ad asset."
  },
  "updatingAdAsset": {
    "tr": "Reklam öğesi güncelleniyor…",
    "en": "Updating ad asset…"
  },
  "adAssetUpdated": {
    "tr": "Reklam öğesi güncellendi.",
    "en": "Ad asset updated."
  },
  "doYouWantToRemoveThisAsset": {
    "tr": "Bu öğeyi kampanyadan kaldırmak istiyor musunuz?",
    "en": "Do you want to remove this asset from the campaign?"
  },
  "addingAdAsset": {
    "tr": "Reklam öğesi ekleniyor…",
    "en": "Adding ad asset…"
  },
  "adAssetAddedToTheCampaign": {
    "tr": "Reklam öğesi kampanyaya eklendi.",
    "en": "Ad asset added to the campaign."
  },
  "googleAds3": {
    "tr": "GOOGLE ADS /",
    "en": "GOOGLE ADS /"
  },
  "manageYourTargetingAdContentAndResults": {
    "tr": "Hedeflerinizi, reklam içeriklerinizi ve sonuçlarınızı yönetin.",
    "en": "Manage your targeting, ad content and results."
  },
  "report": {
    "tr": "Rapor",
    "en": "Report"
  },
  "compareWithPreviousPeriod": {
    "tr": "Önceki dönemle karşılaştır",
    "en": "Compare with previous period"
  },
  "fetchReport": {
    "tr": "Raporu getir",
    "en": "Fetch report"
  },
  "downloadCsv": {
    "tr": "CSV indir",
    "en": "Download CSV"
  },
  "rowS": {
    "tr": "satır",
    "en": "row(s)"
  },
  "previousPeriod": {
    "tr": "Önceki dönem",
    "en": "Previous period"
  },
  "the10000RowLimitWasReached": {
    "tr": "10.000 satır sınırına ulaşıldı. Daha kısa aralık seçin.",
    "en": "The 10,000-row limit was reached. Select a shorter date range."
  },
  "searchResults": {
    "tr": "Sonuçlarda ara",
    "en": "Search results"
  },
  "impressionS": {
    "tr": "gösterim",
    "en": "impression(s)"
  },
  "conversionS": {
    "tr": "dönüşüm",
    "en": "conversion(s)"
  },
  "showMore": {
    "tr": "Daha fazla göster",
    "en": "Show more"
  },
  "theReportWasSavedWithItsRetrieval": {
    "tr": "Rapor, alındığı tarihle kaydedildi.",
    "en": "The report was saved with its retrieval date."
  },
  "createConversion": {
    "tr": "＋ Dönüşüm oluştur",
    "en": "＋ Create conversion"
  },
  "offlineImport": {
    "tr": "Çevrimdışı aktarım ›",
    "en": "Offline import ›"
  },
  "secondary": {
    "tr": "İkincil",
    "en": "Secondary"
  },
  "installationCode": {
    "tr": "Kurulum kodu",
    "en": "Installation code"
  },
  "editConversion": {
    "tr": "Dönüşümü düzenle",
    "en": "Edit conversion"
  },
  "newConversion": {
    "tr": "Yeni dönüşüm",
    "en": "New conversion"
  },
  "name": {
    "tr": "Ad",
    "en": "Name"
  },
  "website": {
    "tr": "Web sitesi",
    "en": "Website"
  },
  "offlineClick": {
    "tr": "Çevrimdışı tıklama",
    "en": "Offline click"
  },
  "category": {
    "tr": "Kategori",
    "en": "Category"
  },
  "defaultValue": {
    "tr": "Varsayılan değer (",
    "en": "Default value ("
  },
  "clickThroughWindowDays": {
    "tr": "Tıklama sonrası pencere (gün)",
    "en": "Click-through window (days)"
  },
  "count": {
    "tr": "Sayım",
    "en": "Count"
  },
  "onePerClick": {
    "tr": "Tıklama başına bir",
    "en": "One per click"
  },
  "everyConversion": {
    "tr": "Her dönüşüm",
    "en": "Every conversion"
  },
  "enabled2": {
    "tr": "Etkin",
    "en": "Enabled"
  },
  "hidden": {
    "tr": "Gizli",
    "en": "Hidden"
  },
  "primaryOptimizationGoal": {
    "tr": "Birincil optimizasyon hedefi",
    "en": "Primary optimization goal"
  },
  "useDefaultValue": {
    "tr": "Varsayılan değeri kullan",
    "en": "Use default value"
  },
  "addTheWebConversionInstallationCodeTo": {
    "tr": "Web dönüşümünün kurulum kodunu sitenize ekleyin. GA4 kaynaklı dönüşümleri GA4’te yönetin.",
    "en": "Add the web conversion installation code to your website. Manage GA4 conversions in GA4."
  },
  "save": {
    "tr": "Kaydet",
    "en": "Save"
  },
  "conversion": {
    "tr": "Dönüşüm",
    "en": "Conversion"
  },
  "eachRowGclidDateAndTimeValue": {
    "tr": "Her satır: gclid; tarih ve saat; değer; sipariş kimliği. Örnek tarih: 2026-09-20 14:30:00+03:00. En fazla 100 satır.",
    "en": "Each row: gclid; date and time; value; order ID. Example date: 2026-09-20 14:30:00+03:00. Maximum 100 rows."
  },
  "csvContent": {
    "tr": "CSV içeriği",
    "en": "CSV content"
  },
  "gclid20260920143000": {
    "tr": "gclid;2026-09-20 14:30:00+03:00;250;ORDER-1",
    "en": "gclid;2026-09-20 14:30:00+03:00;250;ORDER-1"
  },
  "csvFile": {
    "tr": "CSV dosyası",
    "en": "CSV file"
  },
  "validateRows": {
    "tr": "Satırları doğrula",
    "en": "Validate rows"
  },
  "submitConversions": {
    "tr": "Dönüşümleri gönder",
    "en": "Submit conversions"
  },
  "remarketingLists": {
    "tr": "Yeniden pazarlama listeleri",
    "en": "Remarketing lists"
  },
  "dayS": {
    "tr": "gün ·",
    "en": "day(s) ·"
  },
  "search2": {
    "tr": "· Arama",
    "en": "· Search"
  },
  "display": {
    "tr": "· Görsel",
    "en": "· Display"
  },
  "stopAcceptingNewMembers": {
    "tr": "Yeni üyeleri durdur",
    "en": "Stop accepting new members"
  },
  "acceptNewMembers": {
    "tr": "Yeni üyeleri kabul et",
    "en": "Accept new members"
  },
  "newVisitorAudience": {
    "tr": "Yeni ziyaretçi kitlesi",
    "en": "New visitor audience"
  },
  "audienceName": {
    "tr": "Kitle adı",
    "en": "Audience name"
  },
  "urlContains": {
    "tr": "URL şu ifadeyi içerir",
    "en": "URL contains"
  },
  "products": {
    "tr": "/urunler",
    "en": "/products"
  },
  "membershipDurationDays": {
    "tr": "Üyelik süresi (gün)",
    "en": "Membership duration (days)"
  },
  "theListStartsPopulatingThroughYourWebsite": {
    "tr": "Liste, sitenizdeki Google etiketi ve izin ayarlarıyla dolmaya başlar.",
    "en": "The list starts populating through your website’s Google tag and consent settings."
  },
  "createAudience": {
    "tr": "Kitle oluştur",
    "en": "Create audience"
  },
  "preparePerformanceMaxAudienceSignal": {
    "tr": "Performance Max kitle sinyali hazırla",
    "en": "Prepare Performance Max audience signal"
  },
  "signalName": {
    "tr": "Sinyal adı",
    "en": "Signal name"
  },
  "sourceList": {
    "tr": "Kaynak liste",
    "en": "Source list"
  },
  "createAudienceSignal": {
    "tr": "Kitle sinyali oluştur",
    "en": "Create audience signal"
  },
  "imageAndVideoLibrary": {
    "tr": "Görsel ve video kütüphanesi",
    "en": "Image and video library"
  },
  "uploadNewImageJpegPngOrGif": {
    "tr": "Yeni görsel yükle · JPEG, PNG veya GIF · 5 MB",
    "en": "Upload new image · JPEG, PNG or GIF · 5 MB"
  },
  "refresh2": {
    "tr": "↻ Yenile",
    "en": "↻ Refresh"
  },
  "youtubeVideoPreview": {
    "tr": "YouTube video önizlemesi",
    "en": "YouTube video preview"
  },
  "adAsset": {
    "tr": "Reklam öğesi",
    "en": "Ad asset"
  },
  "watchVideo": {
    "tr": "Videoyu izle ↗",
    "en": "Watch video ↗"
  },
  "addYoutubeVideo": {
    "tr": "YouTube videosu ekle",
    "en": "Add YouTube video"
  },
  "videoName": {
    "tr": "Video adı",
    "en": "Video name"
  },
  "youtubeUrlId": {
    "tr": "YouTube adresi / kimliği",
    "en": "YouTube URL / ID"
  },
  "httpsYoutubeComWatchV": {
    "tr": "https://youtube.com/watch?v=...",
    "en": "https://youtube.com/watch?v=..."
  },
  "addToLibrary": {
    "tr": "Kütüphaneye ekle",
    "en": "Add to library"
  },
  "uploadNewVideo": {
    "tr": "Yeni video yükle",
    "en": "Upload new video"
  },
  "mp4MovOrWebmMaximum250Mb": {
    "tr": "MP4, MOV veya WebM · En fazla 250 MB. YouTube’da liste dışı video olarak hazırlanır.",
    "en": "MP4, MOV or WebM · Maximum 250 MB. Created as an unlisted YouTube video."
  },
  "file": {
    "tr": "Dosya",
    "en": "File"
  },
  "headline": {
    "tr": "Başlık",
    "en": "Headline"
  },
  "description": {
    "tr": "Açıklama",
    "en": "Description"
  },
  "channelIdOptional": {
    "tr": "Kanal kimliği (isteğe bağlı)",
    "en": "Channel ID (optional)"
  },
  "uc": {
    "tr": "UC...",
    "en": "UC..."
  },
  "leaveBlankToUseTheChannelManaged": {
    "tr": "Boşsa Google Ads’in yönettiği kanal kullanılır.",
    "en": "Leave blank to use the channel managed by Google Ads."
  },
  "uploadVideo": {
    "tr": "Videoyu yükle",
    "en": "Upload video"
  },
  "processingVideo": {
    "tr": "Video işleniyor",
    "en": "Processing video"
  },
  "addToAdLibrary": {
    "tr": "Reklam kütüphanesine ekle",
    "en": "Add to ad library"
  },
  "editTitleDescription": {
    "tr": "Başlık/açıklama düzenle",
    "en": "Edit title/description"
  },
  "deleteFromYoutube": {
    "tr": "YouTube’dan sil",
    "en": "Delete from YouTube"
  },
  "videoTitle": {
    "tr": "Video başlığı",
    "en": "Video title"
  },
  "saveVideoDetails": {
    "tr": "Video bilgilerini kaydet",
    "en": "Save video details"
  },
  "merchantCenterLinks": {
    "tr": "Merchant Center bağlantıları",
    "en": "Merchant Center links"
  },
  "linkMerchantCenterAccount": {
    "tr": "Merchant Center hesabı bağla ↗",
    "en": "Link Merchant Center account ↗"
  },
  "googleAnalytics4": {
    "tr": "Google Analytics 4",
    "en": "Google Analytics 4"
  },
  "grantAnalyticsManagementPermissionToYourExisting": {
    "tr": "Mevcut Google bağlantınıza Analytics yönetim izni vererek GA4 mülkünü reklam hesabına bağlayın.",
    "en": "Grant Analytics management permission to your existing Google connection to link a GA4 property to the ad account."
  },
  "grantAnalyticsAccess": {
    "tr": "Analytics erişimi ver",
    "en": "Grant Analytics access"
  },
  "fetchGa4Properties": {
    "tr": "GA4 mülklerini getir",
    "en": "Fetch GA4 properties"
  },
  "ga4Property": {
    "tr": "GA4 mülkü",
    "en": "GA4 property"
  },
  "adPersonalization": {
    "tr": "Reklam kişiselleştirmesi",
    "en": "Ad personalization"
  },
  "linkProperty": {
    "tr": "Mülkü bağla",
    "en": "Link property"
  },
  "setting": {
    "tr": "Ayar",
    "en": "Setting"
  },
  "keyword": {
    "tr": "Kelime",
    "en": "Keyword"
  },
  "match": {
    "tr": "Eşleme",
    "en": "Match"
  },
  "broad": {
    "tr": "Geniş",
    "en": "Broad"
  },
  "phrase": {
    "tr": "Sıralı",
    "en": "Phrase"
  },
  "exact": {
    "tr": "Tam",
    "en": "Exact"
  },
  "day": {
    "tr": "Gün",
    "en": "Day"
  },
  "timesUseThe": {
    "tr": "Saatler",
    "en": "Times use the"
  },
  "timeZoneSplitOvernightIntervalsAcrossTwo": {
    "tr": "saat dilimindedir. Geceyi geçen aralıkları iki güne ayırın.",
    "en": "time zone. Split overnight intervals across two days."
  },
  "excludeRegion": {
    "tr": "Bölgeyi hariç tut",
    "en": "Exclude region"
  },
  "language": {
    "tr": "Dil",
    "en": "Language"
  },
  "turkish": {
    "tr": "Türkçe",
    "en": "Turkish"
  },
  "english": {
    "tr": "İngilizce",
    "en": "English"
  },
  "arabic": {
    "tr": "Arapça",
    "en": "Arabic"
  },
  "device": {
    "tr": "Cihaz",
    "en": "Device"
  },
  "mobile": {
    "tr": "Mobil",
    "en": "Mobile"
  },
  "desktop": {
    "tr": "Bilgisayar",
    "en": "Desktop"
  },
  "tablet": {
    "tr": "Tablet",
    "en": "Tablet"
  },
  "connectedTv": {
    "tr": "Bağlı TV",
    "en": "Connected TV"
  },
  "bidMultiplier": {
    "tr": "Teklif çarpanı",
    "en": "Bid multiplier"
  },
  "1NoChange0Exclude12": {
    "tr": "1 = değişiklik yok, 0 = hariç tut, 1,2 = %20 artır. Otomatik teklif bazı ayarları kabul etmeyebilir.",
    "en": "1 = no change, 0 = exclude, 1.2 = increase by 20%. Automated bidding may not support some settings."
  },
  "visitorList": {
    "tr": "Ziyaretçi listesi",
    "en": "Visitor list"
  },
  "excludeAudience": {
    "tr": "Kitleyi hariç tut",
    "en": "Exclude audience"
  },
  "observationDoNotRestrictTargetingToThis": {
    "tr": "Gözlemle; yalnız bu kitleyle sınırlama",
    "en": "Observation; do not restrict targeting to this audience"
  },
  "age": {
    "tr": "Yaş",
    "en": "Age"
  },
  "gender": {
    "tr": "Cinsiyet",
    "en": "Gender"
  },
  "male": {
    "tr": "Erkek",
    "en": "Male"
  },
  "female": {
    "tr": "Kadın",
    "en": "Female"
  },
  "undetermined": {
    "tr": "Belirlenemeyen",
    "en": "Undetermined"
  },
  "saveToGoogleAds": {
    "tr": "Google Ads’e kaydet",
    "en": "Save to Google Ads"
  },
  "currentTargeting": {
    "tr": "Mevcut hedefleme",
    "en": "Current targeting"
  },
  "excluded": {
    "tr": "Hariç tutulan",
    "en": "Excluded"
  },
  "keywordsAndAudienceCriteria": {
    "tr": "Anahtar kelimeler ve kitle kriterleri",
    "en": "Keywords and audience criteria"
  },
  "excluded2": {
    "tr": "· Hariç tutulan",
    "en": "· Excluded"
  },
  "keywordEditor": {
    "tr": "Kelime düzenleyici",
    "en": "Keyword editor"
  },
  "cpcBidOptional": {
    "tr": "Tıklama teklifi (isteğe bağlı)",
    "en": "CPC bid (optional)"
  },
  "changingTextOrMatchTypeReplacesThe": {
    "tr": "Kelime ve eşleme değişikliği eski kriteri kaldırıp yenisini ekler; geçmiş ölçümler eski kayıtta kalır.",
    "en": "Changing text or match type replaces the old criterion. Historical metrics remain with the old record."
  },
  "cpcBid": {
    "tr": "Tıklama teklifi",
    "en": "CPC bid"
  },
  "assetGroups": {
    "tr": "Öğe grupları",
    "en": "Asset groups"
  },
  "addSearchThemeAudienceSignal": {
    "tr": "Arama teması / kitle sinyali ekle",
    "en": "Add search theme / audience signal"
  },
  "assetGroup": {
    "tr": "Öğe grubu",
    "en": "Asset group"
  },
  "searchTheme": {
    "tr": "Arama teması",
    "en": "Search theme"
  },
  "orAudienceSignal": {
    "tr": "Veya kitle sinyali",
    "en": "Or audience signal"
  },
  "useSearchTheme": {
    "tr": "Arama temasını kullan",
    "en": "Use search theme"
  },
  "addSignal": {
    "tr": "Sinyal ekle",
    "en": "Add signal"
  },
  "addNewAsset": {
    "tr": "Yeni öğe ekle",
    "en": "Add new asset"
  },
  "role": {
    "tr": "Rol",
    "en": "Role"
  },
  "longHeadline": {
    "tr": "Uzun başlık",
    "en": "Long headline"
  },
  "landscapeImage": {
    "tr": "Yatay görsel",
    "en": "Landscape image"
  },
  "squareImage": {
    "tr": "Kare görsel",
    "en": "Square image"
  },
  "video": {
    "tr": "Video",
    "en": "Video"
  },
  "text": {
    "tr": "Metin",
    "en": "Text"
  },
  "libraryAsset": {
    "tr": "Kütüphane öğesi",
    "en": "Library asset"
  },
  "addToAssetGroup": {
    "tr": "Öğe grubuna ekle",
    "en": "Add to asset group"
  },
  "linkedAssets": {
    "tr": "Bağlı öğeler",
    "en": "Linked assets"
  },
  "removeFromGroup": {
    "tr": "Gruptan kaldır",
    "en": "Remove from group"
  },
  "includeSearchPartners": {
    "tr": "Arama iş ortaklarında yayınla",
    "en": "Include search partners"
  },
  "step2": {
    "tr": "Adım",
    "en": "Step"
  },
  "store": {
    "tr": "Mağaza",
    "en": "Store"
  },
  "googlePlay": {
    "tr": "Google Play",
    "en": "Google Play"
  },
  "appStore": {
    "tr": "App Store",
    "en": "App Store"
  },
  "appId": {
    "tr": "Uygulama kimliği",
    "en": "App ID"
  },
  "comCompanyApp123456789": {
    "tr": "com.sirket.uygulama / 123456789",
    "en": "com.company.app / 123456789"
  },
  "noWebsiteRequiredLinksToTheApp": {
    "tr": "Web sitesi gerekmez; uygulama mağazasına yönlenir.",
    "en": "No website required; links to the app store."
  },
  "merchantCenter": {
    "tr": "Merchant Center",
    "en": "Merchant Center"
  },
  "selectAccount": {
    "tr": "Hesap seçin",
    "en": "Select account"
  },
  "productFeedLabel": {
    "tr": "Ürün feed etiketi",
    "en": "Product feed label"
  },
  "priority": {
    "tr": "Öncelik",
    "en": "Priority"
  },
  "low": {
    "tr": "Düşük",
    "en": "Low"
  },
  "medium": {
    "tr": "Orta",
    "en": "Medium"
  },
  "high": {
    "tr": "Yüksek",
    "en": "High"
  },
  "productImagesNamesAndDestinationUrlsCome": {
    "tr": "Ürün görselleri, adları ve hedef adresleri Merchant Center’dan alınır.",
    "en": "Product images, names and destination URLs come from Merchant Center."
  },
  "targetRoasMultiplier": {
    "tr": "Hedef ROAS çarpanı",
    "en": "Target ROAS multiplier"
  },
  "regionAndLanguage": {
    "tr": "Bölge ve dil",
    "en": "Region and language"
  },
  "allEligibleRegions": {
    "tr": "Tüm uygun bölgeler",
    "en": "All eligible regions"
  },
  "allLanguages": {
    "tr": "Tüm diller",
    "en": "All languages"
  },
  "thisCampaignSLanguageComesFromThe": {
    "tr": "Bu türün dili reklam içeriği veya ürün feed’i üzerinden belirlenir.",
    "en": "This campaign’s language comes from the ad content or product feed."
  },
  "channels": {
    "tr": "Yayın kanalları",
    "en": "Channels"
  },
  "allowGoogleToExpandEligibleDestinationPages": {
    "tr": "Google uygun hedef sayfaları genişletebilsin",
    "en": "Allow Google to expand eligible destination pages"
  },
  "productAdReady": {
    "tr": "Ürün reklamı hazır",
    "en": "Product ad ready"
  },
  "merchantCenterProductsWithThe": {
    "tr": "Merchant Center’ın",
    "en": "Merchant Center products with the"
  },
  "feedLabelAreListedInOneAd": {
    "tr": "etiketli ürünleri tek reklam grubunda listelenir.",
    "en": "feed label are listed in one ad group."
  },
  "adText": {
    "tr": "Reklam metinleri",
    "en": "Ad text"
  },
  "businessName": {
    "tr": "İşletme adı ·",
    "en": "Business name ·"
  },
  "format": {
    "tr": "Biçim",
    "en": "Format"
  },
  "image": {
    "tr": "Görsel",
    "en": "Image"
  },
  "removeHeadline": {
    "tr": "Başlığı kaldır",
    "en": "Remove headline"
  },
  "headline2": {
    "tr": "＋ Başlık",
    "en": "＋ Headline"
  },
  "longHeadline2": {
    "tr": "Uzun başlık ·",
    "en": "Long headline ·"
  },
  "removeDescription": {
    "tr": "Açıklamayı kaldır",
    "en": "Remove description"
  },
  "description3": {
    "tr": "＋ Açıklama",
    "en": "＋ Description"
  },
  "atLeastThreeHeadlinesOneLongHeadline": {
    "tr": "En az üç başlık, bir uzun başlık ve iki açıklama; bir açıklama en fazla 60 karakter.",
    "en": "At least three headlines, one long headline and two descriptions; one description must be 60 characters or fewer."
  },
  "imageAndVideoSelection": {
    "tr": "Görsel ve video seçimi",
    "en": "Image and video selection"
  },
  "assetRole": {
    "tr": "Öğe rolü",
    "en": "Asset role"
  },
  "landscapeImage1911": {
    "tr": "Yatay görsel · 1,91:1",
    "en": "Landscape image · 1.91:1"
  },
  "squareImage11": {
    "tr": "Kare görsel · 1:1",
    "en": "Square image · 1:1"
  },
  "squareLogo": {
    "tr": "Kare logo",
    "en": "Square logo"
  },
  "youtubeVideo": {
    "tr": "YouTube videosu",
    "en": "YouTube video"
  },
  "assetSSelected": {
    "tr": "öğe seçildi",
    "en": "asset(s) selected"
  },
  "uploadNewImageVideo": {
    "tr": "Yeni görsel / video yükle ›",
    "en": "Upload new image / video ›"
  },
  "unsuitableDimensions": {
    "tr": "Boyut uygun değil",
    "en": "Unsuitable dimensions"
  },
  "uploadNewImagesFromTheAccountImage": {
    "tr": "Yeni görselleri hesap görsel kütüphanesinden, videoları yönetim merkezi video ekranından yükleyebilirsiniz.",
    "en": "Upload new images from the account image library and videos from the management center’s video screen."
  },
  "finalReview": {
    "tr": "Son kontrol",
    "en": "Final review"
  },
  "adPreview2": {
    "tr": "Reklam önizlemesi",
    "en": "Ad preview"
  },
  "selectedAdVideo": {
    "tr": "Seçilen reklam videosu",
    "en": "Selected ad video"
  },
  "watchSelectedVideo": {
    "tr": "▶ Seçilen videoyu izle",
    "en": "▶ Watch selected video"
  },
  "googleChecksAccountLinksAndAdPolicies": {
    "tr": "Google hesap bağlantılarını ve reklam politikalarını kontrol eder. Oluşturduğunuz kampanyayı ayrıca yayına almalısınız.",
    "en": "Google checks account links and ad policies. Enable your campaign separately after creating it."
  },
  "validatedReadyToCreate": {
    "tr": "✓ Doğrulandı. Oluşturmaya hazır.",
    "en": "✓ Validated. Ready to create."
  },
  "createPaused": {
    "tr": "Duraklatılmış oluştur",
    "en": "Create paused"
  },
  "devicePerformance": {
    "tr": "Cihaz performansı",
    "en": "Device performance"
  },
  "adNetwork": {
    "tr": "Reklam ağı",
    "en": "Ad network"
  },
  "dayAndHour": {
    "tr": "Gün ve saat",
    "en": "Day and hour"
  },
  "geographicPerformance": {
    "tr": "Coğrafi performans",
    "en": "Geographic performance"
  },
  "adPerformance": {
    "tr": "Reklam performansı",
    "en": "Ad performance"
  },
  "landingPages": {
    "tr": "Açılış sayfaları",
    "en": "Landing pages"
  },
  "conversionActions": {
    "tr": "Dönüşüm eylemleri",
    "en": "Conversion actions"
  },
  "searchMapsYoutubeAndOtherGoogleChannels": {
    "tr": "Arama, Haritalar, YouTube ve diğer Google kanalları.",
    "en": "Search, Maps, YouTube and other Google channels."
  },
  "youtubeDiscoverGmailAndImageVideoAds": {
    "tr": "YouTube, Discover, Gmail ve görsel/video reklamlar.",
    "en": "YouTube, Discover, Gmail and image/video ads."
  },
  "shopping": {
    "tr": "Alışveriş",
    "en": "Shopping"
  },
  "adsFromYourMerchantCenterProductFeed": {
    "tr": "Merchant Center ürün feed’inizden reklamlar.",
    "en": "Ads from your Merchant Center product feed."
  },
  "googlePlayOrAppStoreInstalls": {
    "tr": "Google Play veya App Store yüklemeleri.",
    "en": "Google Play or App Store installs."
  },
  "youtubeFeed": {
    "tr": "YouTube akışı",
    "en": "YouTube feed"
  },
  "youtubeInStream": {
    "tr": "YouTube video içi",
    "en": "YouTube in-stream"
  },
  "displayNetwork": {
    "tr": "Görüntülü Reklam Ağı",
    "en": "Display Network"
  },
  "tuesday": {
    "tr": "Salı",
    "en": "Tuesday"
  },
  "wednesday": {
    "tr": "Çarşamba",
    "en": "Wednesday"
  },
  "thursday": {
    "tr": "Perşembe",
    "en": "Thursday"
  },
  "purchase": {
    "tr": "Satın alma",
    "en": "Purchase"
  },
  "leadFormSubmission": {
    "tr": "Form gönderimi",
    "en": "Lead form submission"
  },
  "signUp": {
    "tr": "Kayıt",
    "en": "Sign-up"
  },
  "contact": {
    "tr": "İletişim",
    "en": "Contact"
  },
  "pageView": {
    "tr": "Sayfa görüntüleme",
    "en": "Page view"
  },
  "download": {
    "tr": "İndirme",
    "en": "Download"
  },
  "other": {
    "tr": "Diğer",
    "en": "Other"
  },
  "negativeKeyword": {
    "tr": "Hariç tutulan kelime",
    "en": "Negative keyword"
  },
  "adSchedule": {
    "tr": "Yayın saatleri",
    "en": "Ad schedule"
  },
  "addExcludeRegion": {
    "tr": "Bölge ekle / hariç tut",
    "en": "Add / exclude region"
  },
  "deviceBidExclusion": {
    "tr": "Cihaz teklifi / hariç tut",
    "en": "Device bid / exclusion"
  },
  "excludeAgeRange": {
    "tr": "Yaş aralığı hariç tut",
    "en": "Exclude age range"
  },
  "excludeGender": {
    "tr": "Cinsiyet hariç tut",
    "en": "Exclude gender"
  },
  "detailedReports": {
    "tr": "Ayrıntılı raporlar",
    "en": "Detailed reports"
  },
  "datesComparisonDevicesRegionsSearchTermsAnd": {
    "tr": "Tarih, karşılaştırma, cihaz, bölge, arama terimleri ve CSV",
    "en": "Dates, comparison, devices, regions, search terms and CSV"
  },
  "conversionTracking": {
    "tr": "Dönüşüm ölçümü",
    "en": "Conversion tracking"
  },
  "webConversionsInstallationCodeAndOfflineImport": {
    "tr": "Web dönüşümleri, kurulum kodları ve çevrimdışı aktarım",
    "en": "Web conversions, installation code and offline import"
  },
  "visitorListsAndPerformanceMaxSignals": {
    "tr": "Ziyaretçi listeleri ve Performance Max sinyalleri",
    "en": "Visitor lists and Performance Max signals"
  },
  "imagesAndVideos": {
    "tr": "Görseller ve videolar",
    "en": "Images and videos"
  },
  "addYoutubeVideosAndUploadVideosDirectly": {
    "tr": "YouTube video ekleme ve doğrudan video yükleme",
    "en": "Add YouTube videos and upload videos directly"
  },
  "linkedProducts": {
    "tr": "Bağlı ürünler",
    "en": "Linked products"
  },
  "advancedTargeting": {
    "tr": "Gelişmiş hedefleme",
    "en": "Advanced targeting"
  },
  "negativeKeywordsSchedulesDevicesLanguagesAndExclusions": {
    "tr": "Negatif kelimeler, saatler, cihazlar, diller ve hariç tutmalar",
    "en": "Negative keywords, schedules, devices, languages and exclusions"
  },
  "keywordAndGroupManagement": {
    "tr": "Kelime ve grup yönetimi",
    "en": "Keyword and group management"
  },
  "statusBidsNamesAndRemoval": {
    "tr": "Durum, teklif, ad ve kaldırma işlemleri",
    "en": "Status, bids, names and removal"
  },
  "assetGroupsAndSignals": {
    "tr": "Öğe grupları ve sinyaller",
    "en": "Asset groups and signals"
  },
  "performanceMaxAssetsAndSearchThemes": {
    "tr": "Performance Max öğeleri ve arama temaları",
    "en": "Performance Max assets and search themes"
  },
  "campaignSettings": {
    "tr": "Kampanya ayarları",
    "en": "Campaign settings"
  },
  "nameStartEndAndSearchNetwork": {
    "tr": "Ad, başlangıç, bitiş ve arama ağı",
    "en": "Name, start, end and search network"
  },
  "newCampaignTypes": {
    "tr": "Yeni kampanya türleri",
    "en": "New campaign types"
  },
  "performanceMaxDemandGenShoppingAndApp": {
    "tr": "Performance Max, Demand Gen, Alışveriş ve Uygulama",
    "en": "Performance Max, Demand Gen, Shopping and App"
  },
  "offlineConversions": {
    "tr": "Çevrimdışı dönüşümler",
    "en": "Offline conversions"
  },
  "loadingAssetLibrary": {
    "tr": "Öğe kütüphanesi yükleniyor…",
    "en": "Loading asset library…"
  },
  "loadingAudiences": {
    "tr": "Kitleler yükleniyor…",
    "en": "Loading audiences…"
  },
  "loadingCampaignSettings": {
    "tr": "Kampanya ayarları yükleniyor…",
    "en": "Loading campaign settings…"
  },
  "loadingLibraryAndLinks": {
    "tr": "Kütüphane ve bağlantılar yükleniyor…",
    "en": "Loading library and links…"
  },
  "loadingGoogleAdsData": {
    "tr": "Google Ads verileri yükleniyor…",
    "en": "Loading Google Ads data…"
  },
  "couldNotReadTheImage": {
    "tr": "Görsel okunamadı.",
    "en": "Could not read the image."
  },
  "imageUploadedToTheGoogleAdsLibrary2": {
    "tr": "Görsel Google Ads kütüphanesine yüklendi.",
    "en": "Image uploaded to the Google Ads library."
  },
  "preparingReportAndComparison": {
    "tr": "Rapor ve karşılaştırma hazırlanıyor…",
    "en": "Preparing report and comparison…"
  },
  "impressions2": {
    "tr": "Gösterim",
    "en": "Impressions"
  },
  "clicks2": {
    "tr": "Tıklama",
    "en": "Clicks"
  },
  "result": {
    "tr": "Sonuç",
    "en": "Result"
  },
  "period": {
    "tr": "Dönem",
    "en": "Period"
  },
  "conversionValue": {
    "tr": "Dönüşüm değeri",
    "en": "Conversion value"
  },
  "selected3": {
    "tr": "Seçilen",
    "en": "Selected"
  },
  "previous": {
    "tr": "Önceki",
    "en": "Previous"
  },
  "manageThisConversionInItsSourceApplication": {
    "tr": "Bu dönüşüm kaynak uygulamasından yönetilir.",
    "en": "Manage this conversion in its source application."
  },
  "savingConversion": {
    "tr": "Dönüşüm kaydediliyor…",
    "en": "Saving conversion…"
  },
  "conversionSaved": {
    "tr": "Dönüşüm kaydedildi.",
    "en": "Conversion saved."
  },
  "selectACsvNoLargerThan1": {
    "tr": "En fazla 1 MB CSV seçin.",
    "en": "Select a CSV no larger than 1 MB."
  },
  "eachRowMustContainAnIdDate": {
    "tr": "Satırda kimlik, tarih, değer ve isteğe bağlı sipariş kimliği olmalı.",
    "en": "Each row must contain an ID, date, value and optional order ID."
  },
  "validatingConversions": {
    "tr": "Dönüşümler doğrulanıyor…",
    "en": "Validating conversions…"
  },
  "submittingConversions": {
    "tr": "Dönüşümler gönderiliyor…",
    "en": "Submitting conversions…"
  },
  "rowsChangedValidateAgain": {
    "tr": "Satırlar değişti. Tekrar doğrulayın.",
    "en": "Rows changed. Validate again."
  },
  "rowsValidated": {
    "tr": "Satırlar doğrulandı.",
    "en": "Rows validated."
  },
  "someRowsWereNotAccepted": {
    "tr": "Bazı satırlar kabul edilmedi.",
    "en": "Some rows were not accepted."
  },
  "conversionsSubmitted": {
    "tr": "Dönüşümler gönderildi.",
    "en": "Conversions submitted."
  },
  "creatingAudience": {
    "tr": "Kitle oluşturuluyor…",
    "en": "Creating audience…"
  },
  "audienceCreated": {
    "tr": "Kitle oluşturuldu.",
    "en": "Audience created."
  },
  "preparingAudienceSignal": {
    "tr": "Kitle sinyali hazırlanıyor…",
    "en": "Preparing audience signal…"
  },
  "audienceSignalCreated": {
    "tr": "Kitle sinyali oluşturuldu.",
    "en": "Audience signal created."
  },
  "addingVideoToLibrary": {
    "tr": "Video kütüphaneye ekleniyor…",
    "en": "Adding video to library…"
  },
  "videoAdded": {
    "tr": "Video eklendi.",
    "en": "Video added."
  },
  "selectMp4MovOrWebmMaximum250": {
    "tr": "MP4, MOV veya WebM seçin; en fazla 250 MB.",
    "en": "Select MP4, MOV or WebM; maximum 250 MB."
  },
  "uploadingVideoThisMayTakeAFew": {
    "tr": "Video yükleniyor; birkaç dakika sürebilir…",
    "en": "Uploading video; this may take a few minutes…"
  },
  "videoFileCouldNotBeUploaded": {
    "tr": "Video dosyası yüklenemedi.",
    "en": "Video file could not be uploaded."
  },
  "uploading": {
    "tr": "Yükleniyor",
    "en": "Uploading"
  },
  "processing": {
    "tr": "İşleniyor",
    "en": "Processing"
  },
  "readyToUse": {
    "tr": "Kullanıma hazır",
    "en": "Ready to use"
  },
  "failed": {
    "tr": "Başarısız",
    "en": "Failed"
  },
  "unavailable": {
    "tr": "Kullanılamıyor",
    "en": "Unavailable"
  },
  "addingVideoToAdLibrary": {
    "tr": "Video reklam kütüphanesine ekleniyor…",
    "en": "Adding video to ad library…"
  },
  "editTheVideoTitleAndDescriptionBelow": {
    "tr": "Video başlığını ve açıklamasını aşağıdan düzenleyin.",
    "en": "Edit the video title and description below."
  },
  "savingVideoDetails": {
    "tr": "Video bilgileri kaydediliyor…",
    "en": "Saving video details…"
  },
  "videoDetailsUpdated": {
    "tr": "Video bilgileri güncellendi.",
    "en": "Video details updated."
  },
  "thisVideoWillAlsoBePermanentlyDeleted": {
    "tr": "Bu video YouTube’dan da kalıcı olarak silinecek. Silmek istiyor musunuz?",
    "en": "This video will also be permanently deleted from YouTube. Do you want to delete it?"
  },
  "deletingVideo": {
    "tr": "Video siliniyor…",
    "en": "Deleting video…"
  },
  "videoRemoved": {
    "tr": "Video kaldırıldı.",
    "en": "Video removed."
  },
  "preparingAnalyticsPermission": {
    "tr": "Analytics izni hazırlanıyor…",
    "en": "Preparing Analytics permission…"
  },
  "loadingAnalyticsProperties": {
    "tr": "Analytics mülkleri yükleniyor…",
    "en": "Loading Analytics properties…"
  },
  "linkingGa4": {
    "tr": "GA4 bağlanıyor…",
    "en": "Linking GA4…"
  },
  "ga4PropertyLinked": {
    "tr": "GA4 mülkü bağlandı.",
    "en": "GA4 property linked."
  },
  "updatingKeyword": {
    "tr": "Kelime güncelleniyor…",
    "en": "Updating keyword…"
  },
  "keywordUpdated": {
    "tr": "Kelime güncellendi.",
    "en": "Keyword updated."
  },
  "removingAsset": {
    "tr": "Öğe kaldırılıyor…",
    "en": "Removing asset…"
  },
  "assetRemoved": {
    "tr": "Öğe kaldırıldı.",
    "en": "Asset removed."
  },
  "groupUpdated": {
    "tr": "Grup güncellendi.",
    "en": "Group updated."
  },
  "savingCampaignSettings": {
    "tr": "Kampanya ayarları kaydediliyor…",
    "en": "Saving campaign settings…"
  },
  "campaignSettingsUpdated": {
    "tr": "Kampanya ayarları güncellendi.",
    "en": "Campaign settings updated."
  },
  "addingContentToAssetGroup": {
    "tr": "Öğe grubuna içerik ekleniyor…",
    "en": "Adding content to asset group…"
  },
  "contentAddedToAssetGroup": {
    "tr": "İçerik öğe grubuna eklendi.",
    "en": "Content added to asset group."
  },
  "enterANameAndDailyBudget": {
    "tr": "Ad ve günlük bütçe girin.",
    "en": "Enter a name and daily budget."
  },
  "enterAValidDestinationWebsiteUrl": {
    "tr": "Geçerli hedef web adresi girin.",
    "en": "Enter a valid destination website URL."
  },
  "enterTheAppId": {
    "tr": "Uygulama kimliğini girin.",
    "en": "Enter the app ID."
  },
  "selectAMerchantCenterAccount": {
    "tr": "Merchant Center hesabı seçin.",
    "en": "Select a Merchant Center account."
  },
  "enterAHeadlineAndTwoDescriptions": {
    "tr": "Başlık ve iki açıklama girin.",
    "en": "Enter a headline and two descriptions."
  },
  "creatingCampaign": {
    "tr": "Kampanya oluşturuluyor…",
    "en": "Creating campaign…"
  },
  "googleAdsIsValidating": {
    "tr": "Google Ads doğruluyor…",
    "en": "Google Ads is validating…"
  },
  "campaignChangedValidateAgain": {
    "tr": "Kampanya değişti. Tekrar doğrulayın.",
    "en": "Campaign changed. Validate again."
  },
  "detailsChangedDuringValidation": {
    "tr": "Doğrulama sırasında bilgiler değişti.",
    "en": "Details changed during validation."
  },
  "googleAdsValidationSuccessful2": {
    "tr": "Google Ads doğrulaması başarılı.",
    "en": "Google Ads validation successful."
  },
  "campaignCreatedPaused": {
    "tr": "Kampanya duraklatılmış oluşturuldu.",
    "en": "Campaign created paused."
  },
  "adStudio": {
    "tr": "REKLAM STÜDYOSU",
    "en": "AD STUDIO"
  },
  "prepareYourMessage": {
    "tr": "Mesajınızı hazırlayın",
    "en": "Prepare your message"
  },
  "varyYourHeadlinesAndDescriptionsPreviewDifferent": {
    "tr": "Başlıkları ve açıklamaları çeşitlendirin; önizlemede farklı birleşimleri görün.",
    "en": "Vary your headlines and descriptions; preview different combinations."
  },
  "headlineS": {
    "tr": "başlık ·",
    "en": "headline(s) ·"
  },
  "descriptionS": {
    "tr": "açıklama",
    "en": "description(s)"
  },
  "contentReadiness": {
    "tr": "İçerik hazırlığı",
    "en": "Content readiness"
  },
  "aGuideBasedOnTheNumberAnd": {
    "tr": "Metin sayısı ve çeşitliliğine göre yardımcı gösterge. Google’ın reklam gücü değerlendirmesi değildir.",
    "en": "A guide based on the number and variety of text assets. This is not Google’s ad strength assessment."
  },
  "businessName2": {
    "tr": "İşletme adı",
    "en": "Business name"
  },
  "yourBrandName": {
    "tr": "Markanızın adı",
    "en": "Your brand name"
  },
  "yourMainMessageInOneSentence": {
    "tr": "Tek bir cümlede ana mesajınız",
    "en": "Your main message in one sentence"
  },
  "headlines": {
    "tr": "Başlıklar",
    "en": "Headlines"
  },
  "atLeast3HeadlinesAreRequiredVary": {
    "tr": "En az 3 başlık gerekli. Hizmet, avantaj ve çağrı için farklı ifadeler kullanın.",
    "en": "At least 3 headlines are required. Vary your service, benefit and call to action."
  },
  "add15ShortHeadlinesThatComplement": {
    "tr": "1–5 kısa başlık ekleyin. Görselin mesajını tamamlayın.",
    "en": "Add 1–5 short headlines that complement the image."
  },
  "letGoogleChooseThePosition": {
    "tr": "Konumu Google seçsin",
    "en": "Let Google choose the position"
  },
  "pinToPosition1": {
    "tr": "1. konuma sabitle",
    "en": "Pin to position 1"
  },
  "pinToPosition2": {
    "tr": "2. konuma sabitle",
    "en": "Pin to position 2"
  },
  "pinToPosition3": {
    "tr": "3. konuma sabitle",
    "en": "Pin to position 3"
  },
  "remove2": {
    "tr": "kaldır",
    "en": "remove"
  },
  "thisHeadlineIsRepeatedTryADifferent": {
    "tr": "Bu başlık tekrar ediyor; farklı bir avantaj yazın.",
    "en": "This headline is repeated; try a different benefit."
  },
  "addHeadline": {
    "tr": "＋ Başlık ekle",
    "en": "＋ Add headline"
  },
  "descriptions": {
    "tr": "Açıklamalar",
    "en": "Descriptions"
  },
  "atLeast2DescriptionsAreRequiredExplain": {
    "tr": "En az 2 açıklama gerekli. Hizmetinizin faydasını ve sonraki adımı anlatın.",
    "en": "At least 2 descriptions are required. Explain your service’s benefit and the next step."
  },
  "add15DescriptionsWithAClear": {
    "tr": "1–5 açıklama ekleyin. Kısa ve anlaşılır bir çağrı kullanın.",
    "en": "Add 1–5 descriptions with a clear, concise call to action."
  },
  "explainTheBenefitYouOfferCustomers": {
    "tr": "Müşteriye sunduğunuz faydayı anlatın.",
    "en": "Explain the benefit you offer customers."
  },
  "describeYourOfferAndCallToAction": {
    "tr": "Teklifinizi ve harekete geçme çağrısını yazın.",
    "en": "Describe your offer and call to action."
  },
  "thisDescriptionIsRepeated": {
    "tr": "Bu açıklama tekrar ediyor.",
    "en": "This description is repeated."
  },
  "addDescription": {
    "tr": "＋ Açıklama ekle",
    "en": "＋ Add description"
  },
  "displayPath1": {
    "tr": "Görünen adres yolu 1",
    "en": "Display path 1"
  },
  "services": {
    "tr": "hizmetler",
    "en": "services"
  },
  "displayPath2": {
    "tr": "Görünen adres yolu 2",
    "en": "Display path 2"
  },
  "appointment": {
    "tr": "randevu",
    "en": "appointment"
  },
  "pathsOnlyChangeTheUrlDisplayedIn": {
    "tr": "Yollar yalnız reklamda görünen adresi değiştirir. Başlık sabitlemek, Google’ın deneyebileceği birleşimleri azaltır.",
    "en": "Paths only change the URL displayed in the ad. Pinning headlines reduces the combinations Google can test."
  },
  "livePreview": {
    "tr": "Canlı önizleme",
    "en": "Live preview"
  },
  "previousCombination": {
    "tr": "Önceki birleşim",
    "en": "Previous combination"
  },
  "combination": {
    "tr": "Birleşim",
    "en": "Combination"
  },
  "nextCombination": {
    "tr": "Sonraki birleşim",
    "en": "Next combination"
  },
  "sponsored": {
    "tr": "Sponsorlu ·",
    "en": "Sponsored ·"
  },
  "learnMore": {
    "tr": "Daha fazla bilgi",
    "en": "Learn more"
  },
  "exampleOnlyGoogleDeterminesActualLayoutsAnd": {
    "tr": "Gösterim örneğidir. Gerçek yerleşim ve birleşimler Google tarafından belirlenir.",
    "en": "Example only. Google determines actual layouts and combinations."
  },
  "serviceOrBrandName": {
    "tr": "Hizmet veya marka adı",
    "en": "Service or brand name"
  },
  "yourCustomerBenefit": {
    "tr": "Müşteriye sunduğunuz avantaj",
    "en": "Your customer benefit"
  },
  "bookAnAppointmentRequestAQuote": {
    "tr": "Randevu alın / Teklif isteyin",
    "en": "Book an appointment / Request a quote"
  },
  "yourAdHeadline": {
    "tr": "Reklam başlığınız",
    "en": "Your ad headline"
  },
  "yourAdHeadlines": {
    "tr": "Reklam başlıklarınız",
    "en": "Your ad headlines"
  },
  "yourAdDescriptionWillAppearHere": {
    "tr": "Reklam açıklamanız burada görünecek.",
    "en": "Your ad description will appear here."
  },
  "connectGoogleAds": {
    "tr": "Google Ads’i bağlayın",
    "en": "Connect Google Ads"
  },
  "theAdvertisingAccountsYouCanAccessAppear": {
    "tr": "Erişebildiğiniz reklam hesapları burada görünür.",
    "en": "The advertising accounts you can access appear here."
  },
  "connectAccount": {
    "tr": "Hesap bağla",
    "en": "Connect account"
  },
  "addAdAsset": {
    "tr": "Reklam öğesi ekle",
    "en": "Add ad asset"
  },
  "pause": {
    "tr": "Duraklat",
    "en": "Pause"
  },
  "noCampaignSpecificAdAssets": {
    "tr": "Kampanyaya özel reklam öğesi yok.",
    "en": "No campaign-specific ad assets."
  },
  "googleManagesAdAssetsAutomaticallyForThis": {
    "tr": "Bu kampanyada reklam öğeleri Google tarafından otomatik yönetilir.",
    "en": "Google manages ad assets automatically for this campaign."
  },
  "noCustomLocationTarget": {
    "tr": "Özel konum hedefi görünmüyor.",
    "en": "No custom location target."
  },
  "noAdGroups": {
    "tr": "Reklam grubu yok.",
    "en": "No ad groups."
  },
  "noKeywordsYet": {
    "tr": "Henüz anahtar kelime yok.",
    "en": "No keywords yet."
  },
  "noAdsYet": {
    "tr": "Henüz reklam yok.",
    "en": "No ads yet."
  },
  "noCampaignsYet": {
    "tr": "Henüz kampanya yok",
    "en": "No campaigns yet"
  },
  "startTheNewCampaignFlowToPrepare": {
    "tr": "İlk Arama kampanyanızı hazırlamak için yeni kampanya akışını başlatın.",
    "en": "Start the new campaign flow to prepare your first Search campaign."
  },
  "noImagesInThisAccountUploadYour": {
    "tr": "Hesapta görsel yok. Yukarıdan ilk görselinizi yükleyin.",
    "en": "No images in this account. Upload your first image above."
  },
  "noSettingsOfThisType": {
    "tr": "Bu türde ayar yok.",
    "en": "No settings of this type."
  },
  "noCriteria": {
    "tr": "Kriter yok.",
    "en": "No criteria."
  },
  "noAssetGroups": {
    "tr": "Öğe grubu yok.",
    "en": "No asset groups."
  },
  "noAssetsForThisRole": {
    "tr": "Bu rolde öğe yok.",
    "en": "No assets for this role."
  },
  "targeted": {
    "tr": "Hedeflenen",
    "en": "Targeted"
  },
  "campaigns2": {
    "tr": "Kampanyalar",
    "en": "Campaigns"
  },
  "campaign3": {
    "tr": "KAMPANYA",
    "en": "CAMPAIGN"
  },
  "account": {
    "tr": "HESAP",
    "en": "ACCOUNT"
  },
  "basics": {
    "tr": "Temel bilgiler",
    "en": "Basics"
  },
  "addingKeyword": {
    "tr": "Anahtar kelime ekleniyor…",
    "en": "Adding keyword…"
  },
  "searchTerms": {
    "tr": "Arama terimleri",
    "en": "Search terms"
  },
  "app": {
    "tr": "Uygulama",
    "en": "App"
  },
  "maps": {
    "tr": "Haritalar",
    "en": "Maps"
  },
  "monday": {
    "tr": "Pazartesi",
    "en": "Monday"
  },
  "friday": {
    "tr": "Cuma",
    "en": "Friday"
  },
  "saturday": {
    "tr": "Cumartesi",
    "en": "Saturday"
  },
  "sunday": {
    "tr": "Pazar",
    "en": "Sunday"
  },
  "remarketingAudience": {
    "tr": "Yeniden pazarlama kitlesi",
    "en": "Remarketing audience"
  },
  "audiencesAndRemarketing": {
    "tr": "Kitleler ve yeniden pazarlama",
    "en": "Audiences and remarketing"
  },
  "merchantCenterAndGoogleAnalytics4": {
    "tr": "Merchant Center ve Google Analytics 4",
    "en": "Merchant Center and Google Analytics 4"
  },
  "newCampaign2": {
    "tr": "Yeni kampanya",
    "en": "New campaign"
  },
  "spend": {
    "tr": "Harcama",
    "en": "Spend"
  },
  "dimension": {
    "tr": "Boyut",
    "en": "Dimension"
  },
  "spend2": {
    "tr": "Harcama (",
    "en": "Spend ("
  },
  "savingAudienceStatus": {
    "tr": "Kitle durumu kaydediliyor…",
    "en": "Saving audience status…"
  },
  "adVideo": {
    "tr": "Reklam videosu",
    "en": "Ad video"
  },
  "rejectedByGoogle": {
    "tr": "Google kabul etmedi",
    "en": "Rejected by Google"
  },
  "savingTargeting": {
    "tr": "Hedefleme kaydediliyor…",
    "en": "Saving targeting…"
  },
  "savingStatus": {
    "tr": "Durum kaydediliyor…",
    "en": "Saving status…"
  },
  "savingGroup": {
    "tr": "Grup kaydediliyor…",
    "en": "Saving group…"
  },
  "savingSignal": {
    "tr": "Sinyal kaydediliyor…",
    "en": "Saving signal…"
  },
  "signalAdded": {
    "tr": "Sinyal eklendi.",
    "en": "Signal added."
  },
  "settingSaved": {
    "tr": "Ayar kaydedildi.",
    "en": "Setting saved."
  },
  "position": {
    "tr": "konumu",
    "en": "position"
  },
  "headline3": {
    "tr": "Başlık ",
    "en": "Headline "
  },
  "description4": {
    "tr": "Açıklama ",
    "en": "Description "
  },
  "remove3": {
    "tr": " kaldır",
    "en": " remove"
  },
  "position2": {
    "tr": " konumu",
    "en": " position"
  },
  "serverMessage1": {
    "tr": "Google Ads API yanıtı alınamadı.",
    "en": "Could not retrieve a Google Ads API response."
  },
  "serverMessage2": {
    "tr": "Google bu kampanya için en az ",
    "en": "Google requires a daily budget of at least "
  },
  "serverMessage3": {
    "tr": " günlük bütçe istiyor.",
    "en": " for this campaign."
  },
  "serverMessage4": {
    "tr": "Google Ads çevrimdışı erişim izni eksik. Hesabı yeniden bağlayın.",
    "en": "Google Ads offline access permission is missing. Reconnect the account."
  },
  "serverMessage5": {
    "tr": "Google Ads oturumu yenilenemedi. Hesabı yeniden bağlayın.",
    "en": "Could not refresh the Google Ads session. Reconnect the account."
  },
  "serverMessage6": {
    "tr": "Google Ads bağlantı isteği doğrulanamadı. Workspace’ten yeniden başlatın.",
    "en": "Could not verify the Google Ads connection request. Restart it from your workspace."
  },
  "serverMessage7": {
    "tr": "Google Ads doğrulama kodu bulunamadı.",
    "en": "Google Ads authorization code not found."
  },
  "serverMessage8": {
    "tr": "Google Ads hesabı doğrulanamadı.",
    "en": "Could not verify the Google Ads account."
  },
  "serverMessage9": {
    "tr": "Google Ads hesap sayısı sınırına ulaşıldı.",
    "en": "The Google Ads account limit has been reached."
  },
  "serverMessage10": {
    "tr": "Bağlantı #",
    "en": "Connection #"
  },
  "serverMessage11": {
    "tr": "Geçerli, en fazla 366 günlük geçmiş bir tarih aralığı seçin.",
    "en": "Select a valid past date range of up to 366 days."
  },
  "serverMessage12": {
    "tr": "Google Ads API kart borcu veya ödenmemiş bakiyeyi bu hesap için sağlamıyor.",
    "en": "The Google Ads API does not provide card debt or outstanding balance for this account."
  },
  "serverMessage13": {
    "tr": "Faturalar borç bakiyesi anlamına gelmez. Ödenmemiş tutarı Google Ads ödeme ekranından kontrol edin.",
    "en": "Invoices do not represent outstanding balances. Check unpaid amounts on the Google Ads payments screen."
  },
  "serverMessage14": {
    "tr": "Fatura listesi erişilebilir değil.",
    "en": "The invoice list is not accessible."
  },
  "serverMessage15": {
    "tr": "Faturalama verisi erişilebilir değil: ",
    "en": "Billing data is not accessible: "
  },
  "serverMessage16": {
    "tr": "Geçerli kampanya seçin.",
    "en": "Select a valid campaign."
  },
  "serverMessage17": {
    "tr": "Kampanya bulunamadı.",
    "en": "Campaign not found."
  },
  "serverMessage18": {
    "tr": "Geçerli reklam grubu, anahtar kelime ve eşleme türü seçin.",
    "en": "Select a valid ad group, keyword and match type."
  },
  "serverMessage19": {
    "tr": "Reklam grubu bu kampanyaya ait değil.",
    "en": "The ad group does not belong to this campaign."
  },
  "serverMessage20": {
    "tr": "Reklam grubu, web adresi, 3–15 başlık ve 2–4 açıklama gerekli.",
    "en": "An ad group, website URL, 3–15 headlines and 2–4 descriptions are required."
  },
  "serverMessage21": {
    "tr": "Başlıklar en fazla 30 karakter olabilir.",
    "en": "Headlines must be 30 characters or fewer."
  },
  "serverMessage22": {
    "tr": "Açıklamalar en fazla 90 karakter olabilir.",
    "en": "Descriptions must be 90 characters or fewer."
  },
  "serverMessage23": {
    "tr": "Arama kampanyasına ait reklam grubu seçin.",
    "en": "Select an ad group belonging to a Search campaign."
  },
  "serverMessage24": {
    "tr": "Geçerli kampanya ve durum seçin.",
    "en": "Select a valid campaign and status."
  },
  "serverMessage25": {
    "tr": "Geçerli kampanya ve günlük bütçe seçin.",
    "en": "Select a valid campaign and daily budget."
  },
  "serverMessage26": {
    "tr": "Bu bütçe başka kampanyalarla paylaşılıyor; Google Ads’te ayrı bütçe atayın.",
    "en": "This budget is shared with other campaigns; assign a separate budget in Google Ads."
  },
  "serverMessage27": {
    "tr": "Kampanya bütçesi bulunamadı.",
    "en": "Campaign budget not found."
  },
  "serverMessage28": {
    "tr": "Yarıçap 1–500 km ve şehir bilgisi gerekli.",
    "en": "A radius of 1–500 km and a city are required."
  },
  "serverMessage29": {
    "tr": "Bölge veya kilometre yarıçapı seçin.",
    "en": "Select a region or radius in kilometers."
  },
  "serverMessage30": {
    "tr": "Ad, günlük bütçe, web adresi, 3 başlık, 2 açıklama ve anahtar kelime gerekli.",
    "en": "A name, daily budget, website URL, 3 headlines, 2 descriptions and keywords are required."
  },
  "serverMessage31": {
    "tr": "Başlık, açıklama veya anahtar kelime sayısı sınırı aşıldı.",
    "en": "The headline, description or keyword count limit was exceeded."
  },
  "serverMessage32": {
    "tr": "Reklam başlıkları en fazla 30 karakter olabilir.",
    "en": "Ad headlines must be 30 characters or fewer."
  },
  "serverMessage33": {
    "tr": " bütçe ",
    "en": " budget "
  },
  "serverMessage34": {
    "tr": "Geçerli bölge seçin.",
    "en": "Select a valid region."
  },
  "serverMessage35": {
    "tr": "En fazla 50 hariç tutulan kelime ekleyin.",
    "en": "Add no more than 50 negative keywords."
  },
  "serverMessage36": {
    "tr": "Hariç tutulan kelimeler 1–80 karakter olmalı.",
    "en": "Negative keywords must be 1–80 characters long."
  },
  "serverMessage37": {
    "tr": "Google Ads doğrulaması geçti. Kampanya henüz oluşturulmadı.",
    "en": "Google Ads validation passed. The campaign has not been created yet."
  },
  "serverMessage38": {
    "tr": "Başlık sabitlemesi geçersiz.",
    "en": "Invalid headline pinning."
  },
  "serverMessage39": {
    "tr": "Görünen adres yolları en fazla 15 karakter ve eğik çizgisiz olmalı.",
    "en": "Display paths must be 15 characters or fewer and contain no slashes."
  },
  "serverMessage40": {
    "tr": "Geçerli tıklama başı teklif sınırı seçin.",
    "en": "Select a valid maximum CPC bid."
  },
  "serverMessage41": {
    "tr": "Geçerli hedef teklif girin.",
    "en": "Enter a valid target bid."
  },
  "serverMessage42": {
    "tr": "Geçerli kampanya tarihi girin.",
    "en": "Enter a valid campaign date."
  },
  "serverMessage43": {
    "tr": "Bitiş tarihi başlangıçtan önce olamaz.",
    "en": "End date cannot be before start date."
  },
  "serverMessage44": {
    "tr": "Bu kampanya türünün teklif stratejisi ayrı yönetilir.",
    "en": "This campaign type’s bidding strategy is managed separately."
  },
  "serverMessage45": {
    "tr": "Görsel en fazla 5 MB olabilir.",
    "en": "Images must be no larger than 5 MB."
  },
  "serverMessage46": {
    "tr": "Geçerli JPEG, PNG veya GIF görseli seçin (en fazla 5 MB).",
    "en": "Select a valid JPEG, PNG or GIF image (maximum 5 MB)."
  },
  "serverMessage47": {
    "tr": "Görsel reklam için 1–5 başlık, 1–5 açıklama, uzun başlık ve işletme adı gerekli.",
    "en": "A Display ad requires 1–5 headlines, 1–5 descriptions, a long headline and a business name."
  },
  "serverMessage48": {
    "tr": "Başlıklar en fazla 30 karakter olmalı.",
    "en": "Headlines must be no longer than 30 characters."
  },
  "serverMessage49": {
    "tr": "Açıklamalar en fazla 90 karakter olmalı.",
    "en": "Descriptions must be no longer than 90 characters."
  },
  "serverMessage50": {
    "tr": "En az bir yatay görsel ve bir kare görsel seçin.",
    "en": "Select at least one landscape and one square image."
  },
  "serverMessage51": {
    "tr": "Görsel sayısı sınırı aşıldı.",
    "en": "The image count limit was exceeded."
  },
  "serverMessage52": {
    "tr": "Görsel bu reklam hesabına ait değil.",
    "en": "The image does not belong to this advertising account."
  },
  "serverMessage53": {
    "tr": "Toplam en fazla 15 reklam görseli seçin.",
    "en": "Select no more than 15 ad images in total."
  },
  "serverMessage54": {
    "tr": "Seçilen görseller Google Ads hesabında bulunamadı.",
    "en": "The selected images were not found in this Google Ads account."
  },
  "serverMessage55": {
    "tr": "Yarıçap 1–500 km ve şehir gerekli.",
    "en": "A radius of 1–500 km and a city are required."
  },
  "serverMessage56": {
    "tr": "Konum hedefi seçin.",
    "en": "Select a location target."
  },
  "serverMessage57": {
    "tr": "Görsel kampanyaya ait reklam grubu ve hedef adresi gerekli.",
    "en": "An ad group belonging to a Display campaign and a destination URL are required."
  },
  "serverMessage58": {
    "tr": "Bu kampanyaya ait reklam ve geçerli durum seçin.",
    "en": "Select an ad belonging to this campaign and a valid status."
  },
  "serverMessage59": {
    "tr": "Geçerli telefon ve ülke kodu girin.",
    "en": "Enter a valid phone number and country code."
  },
  "serverMessage60": {
    "tr": "Site bağlantısı en fazla 25 karakter ve geçerli URL içermeli.",
    "en": "A sitelink must contain a valid URL and text of up to 25 characters."
  },
  "serverMessage61": {
    "tr": "Bağlantı açıklamaları en fazla 35 karakter olmalı.",
    "en": "Link descriptions must be 35 characters or fewer."
  },
  "serverMessage62": {
    "tr": "Vurgu metni 1–25 karakter olmalı.",
    "en": "Callout text must be 1–25 characters long."
  },
  "serverMessage63": {
    "tr": "Uzantı türü desteklenmiyor.",
    "en": "This extension type is not supported."
  },
  "serverMessage64": {
    "tr": "Bu kampanya türünün otomatik reklam öğeleri Google Ads üzerinden yönetilir.",
    "en": "Manage this campaign type’s automated ad assets in Google Ads."
  },
  "serverMessage65": {
    "tr": "Google Ads bağlantısı bulunamadı.",
    "en": "Google Ads connection not found."
  },
  "serverMessage66": {
    "tr": "Workspace bulunamadı.",
    "en": "Workspace not found."
  },
  "serverMessage67": {
    "tr": "Reklam hesabı bu workspace için bulunamadı.",
    "en": "Advertising account not found for this workspace."
  },
  "serverMessage68": {
    "tr": "Yönetici hesabı raporlanamaz; alt reklam hesabını seçin.",
    "en": "Manager accounts cannot be reported on; select a client advertising account."
  },
  "serverMessage69": {
    "tr": "En az 2 karakterlik bölge adı yazın.",
    "en": "Enter a region name of at least 2 characters."
  },
  "serverMessage70": {
    "tr": "Desteklenen kampanya türü seçin.",
    "en": "Select a supported campaign type."
  },
  "serverMessage71": {
    "tr": "Bilinmeyen Google Ads işlemi.",
    "en": "Unknown Google Ads operation."
  },
  "serverMessage72": {
    "tr": "Geçerli tarih seçin.",
    "en": "Select a valid date."
  },
  "serverMessage73": {
    "tr": "En fazla 366 günlük geçmiş bir aralık seçin.",
    "en": "Select a past date range of up to 366 days."
  },
  "serverMessage74": {
    "tr": "Geçerli kayıt seçin.",
    "en": "Select a valid record."
  },
  "serverMessage75": {
    "tr": " karakter olmalı.",
    "en": " characters long."
  },
  "serverMessage76": {
    "tr": "Geçerli hedef adresi girin.",
    "en": "Enter a valid destination URL."
  },
  "serverMessage77": {
    "tr": "Kayıt bu reklam hesabına ait değil.",
    "en": "The record does not belong to this advertising account."
  },
  "serverMessage78": {
    "tr": "1–500 işlem gönderin.",
    "en": "Submit 1–500 operations."
  },
  "serverMessage79": {
    "tr": "Rapor türü seçin.",
    "en": "Select a report type."
  },
  "serverMessage80": {
    "tr": "Yönetim ekranı seçin.",
    "en": "Select a management screen."
  },
  "serverMessage81": {
    "tr": "Kayıt seçilen kampanyada bulunamadı.",
    "en": "The record was not found in the selected campaign."
  },
  "serverMessage82": {
    "tr": "Kampanya seçin.",
    "en": "Select a campaign."
  },
  "serverMessage83": {
    "tr": "Etkin veya duraklatılmış seçin.",
    "en": "Select enabled or paused."
  },
  "serverMessage84": {
    "tr": "Geçerli teklif girin.",
    "en": "Enter a valid bid."
  },
  "serverMessage85": {
    "tr": "Anahtar kelime seçin.",
    "en": "Select a keyword."
  },
  "serverMessage86": {
    "tr": "Eşleme türü seçin.",
    "en": "Select a match type."
  },
  "serverMessage87": {
    "tr": "Geçerli kelime teklifi girin.",
    "en": "Enter a valid keyword bid."
  },
  "serverMessage88": {
    "tr": "Tarih sırası geçersiz.",
    "en": "Invalid date order."
  },
  "serverMessage89": {
    "tr": "Reklam bu kampanyada bulunamadı.",
    "en": "The ad was not found in this campaign."
  },
  "serverMessage90": {
    "tr": "Düzenleme türü desteklenmiyor.",
    "en": "This edit type is not supported."
  },
  "serverMessage91": {
    "tr": "Yayın günü seçin.",
    "en": "Select an ad schedule day."
  },
  "serverMessage92": {
    "tr": "15 dakikalık dilimler kullanın.",
    "en": "Use 15-minute intervals."
  },
  "serverMessage93": {
    "tr": "Bitiş başlangıçtan sonra olmalı; geceyi iki güne ayırın.",
    "en": "End must be after start; split overnight intervals across two days."
  },
  "serverMessage94": {
    "tr": "Geçerli cihaz ve 0 ya da 0,1–10 teklif çarpanı seçin.",
    "en": "Select a valid device and a bid multiplier of 0 or 0.1–10."
  },
  "serverMessage95": {
    "tr": "Yaş aralığı seçin.",
    "en": "Select an age range."
  },
  "serverMessage96": {
    "tr": "Cinsiyet seçin.",
    "en": "Select a gender."
  },
  "serverMessage97": {
    "tr": "Hedefleme türü seçin.",
    "en": "Select a targeting type."
  },
  "serverMessage98": {
    "tr": "Dönüşüm ayarlarını kontrol edin.",
    "en": "Check the conversion settings."
  },
  "serverMessage99": {
    "tr": "Dönüşüm durumu geçersiz.",
    "en": "Invalid conversion status."
  },
  "serverMessage100": {
    "tr": "Dönüşüm adı",
    "en": "Conversion name"
  },
  "serverMessage101": {
    "tr": "1–100 dönüşüm satırı girin.",
    "en": "Enter 1–100 conversion rows."
  },
  "serverMessage102": {
    "tr": "Etkin çevrimdışı dönüşüm seçin.",
    "en": "Select an enabled offline conversion."
  },
  "serverMessage103": {
    "tr": "Dönüşüm satırları doğrulanamadı.",
    "en": "Could not validate conversion rows."
  },
  "serverMessage104": {
    "tr": "Her satırda yalnız bir tıklama kimliği girin.",
    "en": "Enter only one click ID per row."
  },
  "serverMessage105": {
    "tr": "Tıklama kimliği",
    "en": "Click ID"
  },
  "serverMessage106": {
    "tr": "Dönüşüm zamanı YYYY-MM-DD HH:MM:SS+03:00 biçiminde geçmiş bir tarih olmalı.",
    "en": "Conversion time must be a past date in YYYY-MM-DD HH:MM:SS+03:00 format."
  },
  "serverMessage107": {
    "tr": "Geçerli dönüşüm değeri girin.",
    "en": "Enter a valid conversion value."
  },
  "serverMessage108": {
    "tr": "Sipariş kimliği",
    "en": "Order ID"
  },
  "serverMessage109": {
    "tr": "Bu kitle kaynak sisteminden yönetilir.",
    "en": "Manage this audience in its source system."
  },
  "serverMessage110": {
    "tr": "Kitle durumunu seçin.",
    "en": "Select an audience status."
  },
  "serverMessage111": {
    "tr": "Kitle süresi 1–540 gün olmalı.",
    "en": "Audience membership duration must be 1–540 days."
  },
  "serverMessage112": {
    "tr": "URL parçası",
    "en": "URL fragment"
  },
  "serverMessage113": {
    "tr": "11 karakterlik YouTube video kimliği girin.",
    "en": "Enter an 11-character YouTube video ID."
  },
  "serverMessage114": {
    "tr": "Öğe rolü seçin.",
    "en": "Select an asset role."
  },
  "serverMessage115": {
    "tr": "Kitle bulunamadı.",
    "en": "Audience not found."
  },
  "serverMessage116": {
    "tr": "Öğe türü desteklenmiyor.",
    "en": "This asset type is not supported."
  },
  "serverMessage117": {
    "tr": "Kampanya türü desteklenmiyor.",
    "en": "This campaign type is not supported."
  },
  "serverMessage118": {
    "tr": "Geçerli günlük bütçe girin.",
    "en": "Enter a valid daily budget."
  },
  "serverMessage119": {
    "tr": "Ürün feed etiketi 1–20 büyük harf, sayı, _ veya - olmalı.",
    "en": "The product feed label must be 1–20 uppercase letters, digits, _ or -."
  },
  "serverMessage120": {
    "tr": "Alışveriş önceliği 0–2 olmalı.",
    "en": "Shopping priority must be 0–2."
  },
  "serverMessage121": {
    "tr": "Geçerli uygulama kimliği girin.",
    "en": "Enter a valid app ID."
  },
  "serverMessage122": {
    "tr": " ürünler",
    "en": " products"
  },
  "serverMessage123": {
    "tr": "En fazla 15 öğe seçin.",
    "en": "Select no more than 15 assets."
  },
  "serverMessage124": {
    "tr": "Yatay görsel, kare görsel ve logo seçin.",
    "en": "Select a landscape image, square image and logo."
  },
  "serverMessage125": {
    "tr": "En az bir açıklama 60 karakteri geçmemeli.",
    "en": "At least one description must be 60 characters or fewer."
  },
  "serverMessage126": {
    "tr": " öğeleri",
    "en": " assets"
  },
  "serverMessage127": {
    "tr": "En az bir yayın kanalı seçin.",
    "en": "Select at least one channel."
  },
  "serverMessage128": {
    "tr": "Kare logo seçin.",
    "en": "Select a square logo."
  },
  "serverMessage129": {
    "tr": "Video seçin.",
    "en": "Select a video."
  },
  "serverMessage130": {
    "tr": "Yatay ve kare görsel seçin.",
    "en": "Select landscape and square images."
  },
  "serverMessage131": {
    "tr": "Önce videoyu yükleyin.",
    "en": "Upload the video first."
  },
  "serverMessage132": {
    "tr": "Geçerli yüklenmiş video seçin.",
    "en": "Select a valid uploaded video."
  },
  "serverMessage133": {
    "tr": "Video dosyası bulunamadı veya 250 MB sınırını aşıyor.",
    "en": "Video file not found or exceeds the 250 MB limit."
  },
  "serverMessage134": {
    "tr": "Video biçimi desteklenmiyor.",
    "en": "This video format is not supported."
  },
  "serverMessage135": {
    "tr": "Açıklama en fazla 5000 karakter olabilir.",
    "en": "Description must be 5,000 characters or fewer."
  },
  "serverMessage136": {
    "tr": "YouTube kanal kimliği geçersiz.",
    "en": "Invalid YouTube channel ID."
  },
  "serverMessage137": {
    "tr": "Google video aktarımı başlatılamadı. (HTTP ",
    "en": "Could not start Google video transfer. (HTTP "
  },
  "serverMessage138": {
    "tr": "Video aktarımı tamamlanamadı. (HTTP ",
    "en": "Could not complete video transfer. (HTTP "
  },
  "serverMessage139": {
    "tr": "Video Google tarafından işleniyor. İşlem tamamlanınca kütüphaneye ekleyin.",
    "en": "Google is processing the video. Add it to the library when processing is complete."
  },
  "serverMessage140": {
    "tr": "Video yüklemesi bu hesapta bulunamadı.",
    "en": "The video upload was not found in this account."
  },
  "serverMessage141": {
    "tr": "Video YouTube’dan da kalıcı silinir; silmeyi doğrulayın.",
    "en": "The video will also be permanently deleted from YouTube; confirm deletion."
  },
  "serverMessage142": {
    "tr": "Video silme sonucu doğrulanamadı; kütüphaneyi yenileyin.",
    "en": "Could not verify video deletion; refresh the library."
  },
  "serverMessage143": {
    "tr": "Analytics verisi alınamadı.",
    "en": "Could not retrieve Analytics data."
  },
  "serverMessage144": {
    "tr": "Google Ads işlemi desteklenmiyor.",
    "en": "This Google Ads operation is not supported."
  },
  "serverMessage145": {
    "tr": "Bu dönem için veri yok.",
    "en": "No data for this period."
  },
  "serverMessage146": {
    "tr": "Dönüşüm eylemi yok.",
    "en": "No conversion actions."
  },
  "serverMessage147": {
    "tr": "Kitle listesi yok.",
    "en": "No audience lists."
  },
  "serverMessage148": {
    "tr": "Birincil",
    "en": "Primary"
  },
  "serverMessage149": {
    "tr": "Reklamları yönet",
    "en": "Manage ads"
  }
} as const;
